const en = {
	'common.save': 'Save',
	'common.logout': 'Logout',
	'common.signIn': 'Sign in',
	'common.rename': 'Rename',
	'common.delete': 'Delete',
	'common.upload': 'Upload',
	'common.replace': 'Replace',
	'common.sources': 'Sources',
	'common.hello': 'Hello',
	'common.by': 'by',
	'common.and': 'and',
	'common.privacy': 'Privacy Policy',
	'common.imprint': 'Imprint',
	'common.terms': 'Terms and Conditions',
	'common.copy': 'Copy',
	'common.copied': 'Copied!',
	'common.close': 'Close',
	'common.unread': 'Unread',
	'common.notSelected': 'Not selected',
	'common.confirm': 'Confirm',
	'common.yes': 'Yes',
	'common.no': 'No',
	'common.adminOnly': 'Not yet released to all users',

	'releaseNotes.title': 'Release Notes',
	'releaseNotes.current': 'Current Version',
	'releaseNotes.previous': 'Previous Versions',

	'error.network': 'Connection lost. Please check your internet connection and try again.',
	'error.overloaded': 'The service is temporarily overloaded. Please try again in a moment.',
	'error.notFound': 'Not found',
	'error.unknown': 'Unknown Error',
	'error.creditLimitExceededDay':
		"You've reached today's fair-use limit. Buy extra credits to keep chatting.",
	'error.usageLimitExceeded':
		'This device has reached its usage limit for this exhibit. Please try again from a different network, or ask a team member for help.',

	'nav.data': 'Knowledge Store',
	'nav.briefing': 'All Briefings',
	'nav.history': 'All Chats',
	'nav.instanceAdminSettings': 'Admin Settings',
	'nav.users': 'User Management',
	'nav.organizations': 'Organizations',
	'nav.recentChats': 'Recent Chats',
	'nav.newestBriefings': 'Current Briefings',
	'nav.antonio.chatLink': 'Chat',
	'nav.antonio.galleryLink': 'Gallery',
	'nav.antonio.imagesLink': 'Images',
	'nav.antonio.screen': 'Screen',
	'nav.antonio.screenFeed': 'Feed',
	'nav.antonio.publicChatLink': 'Public chat link',

	'users.title': 'User Management',
	'users.empty': 'No users found',
	'users.role': 'Role',
	'users.role.user': 'User',
	'users.role.admin': 'Admin',
	'users.conversations': 'Conversations',
	'users.messages': 'Messages',
	'users.tokens': 'Tokens',
	'users.credits': 'Lifetime Credits Used',
	'users.periodCredits': 'Credits Used',
	'users.softLimit': 'Soft limit',
	'users.quotaUsed': '% Quota',
	'users.bonusCredits': 'Bonus',
	'users.lifetimeUsage': 'Lifetime Usage',
	'users.creditGrants': 'Credit Grants',
	'users.grantBalance': 'Grant Balance',
	'users.grantAmount': 'Amount',
	'users.grantNote': 'Note (optional)',
	'users.addGrant': 'Add Grant',
	'users.noGrants': 'No grants yet.',
	'users.noConversations': 'No conversations yet.',
	'users.created': 'Created',
	'users.lastActivity': 'Last Activity',
	'users.never': 'Never',
	'users.plan': 'Plan',
	'users.organization': 'Organization',
	'users.organization.all': 'All organizations',
	'users.organization.none': 'No organization',
	'users.organization.joinHint':
		'Joining gives the user the organization’s plan and invoice billing. Leaving keeps both.',
	'users.delete': 'Delete User',
	'users.delete.confirm': 'Delete this user?',
	'users.delete.warning': 'This will permanently delete the user account and all associated data.',
	'users.itsYou': "it's you",
	'users.search': 'Search users…',
	'users.status': 'Status',
	'users.verified': 'Verified',
	'users.notVerified': 'Not verified',
	'users.customBilled': 'Custom billed',
	'users.softDeleted': 'Soft Deleted',
	'users.authProviders': 'Auth Providers',
	'users.activeBriefings': 'Active Briefings',
	'users.exemptCredits': 'Untracked Credits (Briefings)',
	'users.subscribed': 'Subscribed',
	'users.stripeCustomer': 'Stripe Customer',
	'users.stripeSubscription': 'Stripe Subscription',
	'users.stripe': 'Stripe',
	'users.id': 'ID',
	'users.internal': 'Internal User',
	'users.internal.description': 'Excluded from analytics and usage reporting.',
	'users.nav.general': 'General',
	'users.nav.usage': 'Usage & Credits',
	'users.nav.chats': 'Chats',
	'users.nav.debug': 'Debug',
	'users.debug.viewState': 'View State',

	'organizations.title': 'Organizations',
	'organizations.empty': 'No organizations yet',
	'organizations.create': 'New Organization',
	'organizations.create.submit': 'Create',
	'organizations.name': 'Name',
	'organizations.plan.hint': 'Members get this plan when they join. Existing members keep theirs.',
	'organizations.emailDomains': 'Email Domains',
	'organizations.emailDomains.hint':
		'New users with an address at one of these domains join automatically at sign-up. Existing users don’t: add them on their user page.',
	'organizations.emailDomains.input': 'Domain, e.g. example.com',
	'organizations.emailDomains.add': 'Add',
	'organizations.emailDomains.empty': 'No domains',
	'organizations.seats': 'Seats',
	'organizations.seatLimit': 'Seat Limit',
	'organizations.seatLimit.hint':
		'Seats agreed with the customer. Only shown, never enforced. 0 for none.',
	'organizations.logo': 'Logo',
	'organizations.nav.general': 'General',
	'organizations.nav.members': 'Members',
	'organizations.members.empty': 'No members yet. Add users on their user page.',
	'organizations.members.deactivated': 'Deactivated',

	'briefing.title': 'Briefings',
	'briefing.global': 'Common Briefing',
	'briefing.global.askFollowUp': 'Ask follow-up questions',
	'briefing.heading': 'Daily Parliamentary Briefing from {{date}}',
	'briefing.emptyState': 'No briefing available for today. Check back tomorrow!',
	'briefing.loading': "Loading today's briefing...",
	'briefing.errorLoading': 'Error loading briefing',
	'briefing.coveragePeriod': 'Coverage period',
	'briefing.generatedOn': 'Generated on',
	'briefing.personalized.title': 'Your Personalized Briefing',
	'briefing.personalized.coverageLabel': 'Coverage',
	'briefing.personalized.openBriefing': 'Open briefing & ask follow-up questions',
	'briefing.personalized.nullReport': 'Null report',
	'briefing.personalized.resultsFound': 'Results found',
	'briefing.personalized.activeNoResults':
		'Your subscription is active — your first briefing will appear tomorrow.',
	'briefing.personalized.subInactive':
		'Your subscription is paused. Activate it to start receiving daily briefings.',
	'briefing.personalized.emptyState':
		'Set up your personalized briefing to get daily updates on the topics that matter to you.',
	'briefing.subscription.title': 'Personalized Briefings',
	'briefing.subscription.setup': 'Set up your personalized briefing',
	'briefing.subscription.description':
		'Describe your interests in plain language — the more context you give, the better the briefing. Use keywords only for specific terms that must appear verbatim, like names, bill numbers, or organizations.',
	'briefing.subscription.name': 'Name',
	'briefing.subscription.namePlaceholder': 'e.g. Climate & Energy Policy',
	'briefing.subscription.topicPrompt': 'Your prompt to the agent',
	'briefing.subscription.topicPromptPlaceholder':
		'e.g. "I work in communications for an NGO. My focus areas are climate protection, biodiversity, and animal welfare."',
	'briefing.subscription.keywords': 'Exact-match keywords (comma-separated, optional)',
	'briefing.subscription.keywordsPlaceholder':
		'e.g. Building Energy Act, Basic Pension, Federal Network Agency',
	'briefing.subscription.proFeature': 'Pro Feature',
	'briefing.subscription.keywordsProOnly': 'Keyword filtering is available on the Pro plan.',
	'briefing.subscription.keywordsProOnlyLink': 'Upgrade to Pro',
	'briefing.subscription.deliveryEmail': 'Delivery email address',
	'briefing.subscription.deliveryEmailPlaceholder': 'e.g. team@example.com',
	'briefing.subscription.deliveryEmailProOnly':
		'Custom delivery address is available on the Pro plan.',
	'briefing.subscription.deliveryEmailProOnlyLink': 'Upgrade to Pro',
	'briefing.subscription.emailNotifications': 'Notify me via email',
	'briefing.subscription.sendNullReport': 'Also send email when nothing was found (Null Report)',
	'briefing.subscription.isActive': 'Active',
	'briefing.subscription.isPaused': 'Paused',
	'briefing.subscription.personalized': 'Personalized Briefing',
	'briefing.subscription.emailDelivery': 'Emails being delivered to {{email}}',
	'briefing.subscription.save': 'Save',
	'briefing.subscription.saved': 'Saved',
	'briefing.subscription.pause': 'Pause',
	'briefing.subscription.resume': 'Resume',
	'briefing.subscription.delete': 'Delete subscription',
	'briefing.subscription.edit': 'Edit',
	'briefing.subscription.generate.title': 'Generate now',
	'briefing.subscription.generate.from': 'From',
	'briefing.subscription.generate.to': 'To',
	'briefing.subscription.generate.button': 'Generate',
	'briefing.subscription.generate.success': 'Generated — open briefing',
	'briefing.global.info':
		'A daily AI-generated summary of all key parliamentary debates and decisions from the previous day.',
	'briefing.personalized.info':
		'Monitor parliamentary activity on your topics daily. Filtered to your keywords — with a null report when nothing relevant was found. Generated each morning; optionally delivered by email.',
	'briefing.newBriefing': 'New briefing',
	'briefing.subscription.add': 'Add Briefing Subscription',
	'briefing.subscription.globalSubtitle': 'Shared daily briefing for all users',
	'briefing.subscription.freeGate': 'Personal briefings require at least the Essential plan.',
	'briefing.subscription.essentialHint':
		'The Pro plan includes up to 5 personal briefing subscriptions.',
	'briefing.subscription.atLimit': "You've reached the subscription limit for your current plan.",
	'briefing.global.title': 'Global Daily Briefing',

	'auth.signIn.title': 'Sign in',
	'auth.signIn.titleWithInstance': 'Sign in to {{instance}}',
	'auth.signIn.subtitle': 'Sign in to your Botbakery account to get started.',
	'auth.signIn.signinSubtitle': 'Enter your password to continue to your Botbakery account.',
	'auth.signIn.email': 'Email',
	'auth.signIn.password': 'Password',
	'auth.signIn.continueWithEmail': 'Continue',
	'auth.signIn.or': 'or',
	'auth.signIn.signInWithGoogle': 'Continue with Google',
	'auth.signIn.signInWithMicrosoft': 'Continue with Microsoft',
	'auth.signIn.forgotPassword': 'Forgot password?',
	'auth.signIn.createAccount': 'Create an account',
	'auth.signIn.welcome': 'Welcome!',
	'auth.signIn.welcomeBack': 'Welcome back!',
	'auth.signIn.invalidEmail': 'Please enter a valid email address',
	'auth.signIn.fillAllFields': 'Please fill in all fields',

	'auth.activation.title': 'Verify your email address',
	'auth.activation.message':
		'We sent an email with an activation link to {{email}}. Click it to activate your account, then sign in.',
	'auth.activation.resend': 'Resend email',
	'auth.activation.goToSignIn': 'Go to sign in',
	'auth.activation.resent': 'Activation email sent!',

	'auth.reset.title': 'Reset Password',
	'auth.reset.message':
		"Enter the email associated with your account and we'll send you a recovery link",
	'auth.reset.success':
		'Requested a password reset for {{email}}. If this email is associated with a {{instanceName}} account, you have received an email with a reset link.',
	'auth.reset.backToLogin': 'Back to login',
	'auth.reset.email': 'Email',
	'auth.reset.submit': 'Send Reset Link',
	'auth.reset.error': 'Error resetting password',
	'auth.confirmReset.title': 'New Password',
	'auth.confirmReset.success':
		'Password was successfully set! You can now login with your new password.',
	'auth.confirmReset.message': 'Please set a new password',
	'auth.confirmReset.password': 'Password',
	'auth.confirmReset.passwordConfirm': 'Confirm Password',
	'auth.confirmReset.submit': 'Save',
	'auth.confirmReset.toLogin': 'Go to login',

	'auth.signup.title': 'Create your account',
	'auth.signup.subtitle': 'Just a few details to set up your Botbakery account.',
	'auth.signup.firstName': 'First name',
	'auth.signup.lastName': 'Last name',
	'auth.signup.password': 'Password',
	'auth.signup.passwordConfirm': 'Confirm password',
	'auth.signup.passwordsNotEqual': 'Passwords are not equal',
	'auth.signup.submit': 'Create account',
	'auth.signup.notApproved':
		'Unfortunately your account has not been approved yet. Please try again later.',
	'auth.signup.success': 'Your account has been successfully created! You can now log in.',
	'auth.signup.toLogin': 'Go to login',
	'auth.signup.needInfo': 'We need a bit more information from you',
	'auth.signup.acceptTerms': 'I accept the {{terms}} and {{privacy}}',
	'auth.signup.termsRequired': 'You must accept the terms and conditions',
	'auth.signup.fillAllFields': 'Please fill in all required fields',

	'auth.unsubscribe.title': 'Unsubscribe',
	'auth.unsubscribe.success': 'Your email has been successfully deleted from our system.',
	'auth.unsubscribe.confirmMessage': 'Sorry to see you want to leave the waitlist.',
	'auth.unsubscribe.confirmQuestion': 'Are you sure?',
	'auth.unsubscribe.submit': 'Yes, delete my email address',
	'auth.verify.successTitle': 'Email confirmed!',
	'auth.verify.successMessage':
		'Your email address has been verified. You can now sign in to your account.',
	'auth.verify.toLogin': 'Sign in',
	'auth.verify.errorTitle': 'Error',
	'auth.verify.errorMessage': 'Unfortunately there was an error during verification :(',
	'auth.oauth.title': 'Allow access?',
	'auth.oauth.heading': '{{client}} wants to access your account',
	'auth.oauth.permissions': 'Once allowed, the app can:',
	'auth.oauth.permissionAccount': 'See your email address and role',
	'auth.oauth.permissionActAs': 'Use {{instance}} as you, with your permissions',
	'auth.oauth.redirect': 'You will then be sent back to {{client}}.',
	'auth.oauth.redirectLocal': 'You will then be sent back to the app.',
	'auth.oauth.clientClaude': 'Claude',
	'auth.oauth.clientChatgpt': 'ChatGPT',
	'auth.oauth.clientLangdock': 'Langdock',
	'auth.oauth.clientClaudeCode': 'Claude Code',
	'auth.oauth.clientCodex': 'Codex',
	'auth.oauth.clientVscode': 'Visual Studio Code',
	'auth.oauth.clientLocal': 'An app on this computer',
	'auth.oauth.allow': 'Allow',
	'auth.oauth.deny': 'Deny',
	'auth.oauth.invalid':
		'This authorization request is invalid. Start the connection again from your app.',
	'auth.oauth.forbidden': "You don't have access to this app.",

	'chat.welcome': 'how can I help you today?',
	'chat.new': 'New Chat',
	'chat.info': 'Chat Info',
	'chat.rename': 'Rename Chat',
	'chat.delete': 'Delete Chat',
	'chat.delete.question': 'Do you really want to delete this chat?',
	'chat.delete.confirm': 'Yes, delete',
	'chat.delete.cancel': "No, don't delete",
	'chat.share': 'Share',
	'chat.share.intro': 'Choose who can view this conversation.',
	'chat.share.description': 'Anyone with the link can view this conversation.',
	'chat.share.enable': 'Enable sharing',
	'chat.share.hint': 'Disable sharing at any time to revoke access.',
	'chat.share.private': 'Private',
	'chat.share.private.description': 'Only you can access this chat.',
	'chat.share.public': 'Public',
	'chat.share.public.description': 'Anyone with the link can see this chat.',
	'chat.disclaimer': '{{instanceName}} can make mistakes',
	'chat.disclaimerCheckSources': 'Always check all sources carefully',
	'chat.developedBy': 'Developed by',
	'chat.adminView': "You are viewing another user's conversation.",
	'chat.placeholder': 'Ask me anything...',
	'chat.antonioPlaceholder': 'Your answer...',
	'chat.debugInfo': 'Debug Info',
	'chat.retry': 'Regenerate',
	'chat.regenerate': 'Regenerate',
	'chat.incomplete': 'Response interrupted',
	'chat.incompleteTooltip': 'You stopped the generation of the response before it was finished',
	'chat.stopResponse': 'Stop response',
	'chat.attach': 'Attach files',
	'chat.attachment.remove': 'Remove attachment',
	'chat.attachment.dropHere': 'Drop files here',
	'chat.attachment.pages': '{{count}} pages',
	'chat.attachment.error.fileTooLarge': 'Larger than {{limit}} MB',
	'chat.attachment.error.tooManyPages': 'More than {{limit}} pages',
	'chat.attachment.error.tooLong': 'Too much text for one message',
	'chat.attachment.error.unsupportedType': 'File type not supported',
	'chat.attachment.error.unreadable': "The file couldn't be read",
	'chat.attachment.error.failed': 'Upload failed',
	'chat.attachment.error.tooManyFiles': 'At most {{limit}} files per message',
	'chat.attachment.error.tooLongTogether':
		'Together these files have too much text for one message. Remove some of them.',
	'chat.secondarySources': 'Secondary sources',
	'chat.secondarySources.none': 'Off',
	'chat.sources.webSearch': 'Web Search',
	'chat.sources.webSearch.description': 'Search the web for additional information',
	'chat.sources.lobbyregister': 'Lobbyregister',
	'chat.sources.lobbyregister.description':
		'Registered lobbyists and their clients from the Bundestag lobby register',
	'chat.sources.fragdenstaat': 'FragDenStaat',
	'chat.sources.fragdenstaat.description':
		'Freedom of information (IFG) requests to German authorities',
	'chat.sources.abgeordnetenwatch': 'Abgeordnetenwatch',
	'chat.sources.abgeordnetenwatch.description':
		'Politician profiles, side jobs and roll-call votes',
	'chat.lastMessage': 'Last message',
	'chat.emptyHistory': 'No chats available',
	'chat.unnamed': 'Unnamed Chat',
	'chat.apiKeyOrigin': 'Created through the API',
	'chat.untitled': 'Untitled chat',
	'chat.search.placeholder': 'Search chats…',
	'chat.search.noResults': 'No chats match your search.',
	'chat.createdViaApiKey': 'Created via API key "{{name}}"',
	'chat.fetching.thinking': 'thinking...',
	'chat.fetching.analyticalQuery': 'querying database...',
	'chat.fetching.searchSources': 'searching for sources...',
	'chat.fetching.sourcesFound': 'sources found...',
	'chat.reasoning': 'Thoughts',
	'chat.toolCalls': 'Research',
	'chat.tab.toolCalls': 'Actions',
	'chat.tab.reasoning': 'Thoughts',
	'chat.tool.knowledgeBase': 'Knowledge Base',
	'chat.tool.vectorSearch': 'Vector Search',
	'chat.tool.keywordSearch': 'Keyword Search',
	'chat.tool.document': 'Document',
	'chat.tool.context': 'Context',
	'chat.tool.webSearch': 'Web Search',
	'chat.tool.website': 'Website',
	'chat.tool.parliament': 'Parliament',
	'chat.tool.lobbyregister': 'Lobby Register',
	'chat.tool.lobbyregisterEntry': 'Lobby Register Entry',
	'chat.tool.politicians': 'Members of Parliament',
	'chat.tool.votes': 'Votes',
	'chat.tool.kleineAnfragen': 'Kleine Anfragen',
	'chat.tool.fragdenstaat': 'FragDenStaat',
	'chat.tool.briefingStatus': 'Finalizing briefing',
	'chat.tool.generateImage': 'Generate Image',
	'chat.tool.result': 'result',
	'chat.tool.results': 'results',
	'chat.copyPlainText': 'Copy as plain text',
	'chat.copyMarkdown': 'Copy as Markdown',

	'data.emptyState': 'No data available',
	'data.importedOn': 'Imported on',
	'data.document': 'document',
	'data.documents': 'documents',
	'data.speech': 'speech',
	'data.speeches': 'speeches',
	'data.openSource': 'Open source',
	'data.loadError': 'Error loading data',
	'data.latestUpdate': 'Latest Update',
	'data.documentsInKnowledgeStore': 'Documents in Knowledge Store*',
	'data.documentTypesExplanation':
		'* Documents include various types of content such as speeches, articles, laws, and other documents.',
	'data.description':
		'We regularly update this knowledge base with new data. All information listed here is available for the bot to search through and reference in conversations. If something is not listed on this page, the bot will not have access to it.',
	'data.topicsInDebate': 'Topics in this debate:',
	'data.tabs.resources': 'Resources',
	'data.metadata': 'Metadata',
	'data.metadata.document': 'Document Metadata',
	'data.metadata.resource': 'Resource Metadata',
	'settings.instance.nav.importJobs': 'Import Jobs',
	'settings.instance.nav.pdfExtractor': 'PDF Extractor',
	'settings.instance.nav.briefings': 'Briefings',

	'settings.instance.briefings.title': 'Briefing Settings',
	'settings.instance.briefings.dailyBriefing': 'Enable daily briefing',
	'settings.instance.briefings.dailyBriefing.description':
		'Generates a global daily briefing for all users of this instance.',
	'settings.instance.briefings.globalPrompt': 'Global briefing topic',
	'settings.instance.briefings.globalPrompt.description':
		'Describe what the global daily briefing should cover. If left empty, a generic parliamentary overview will be generated.',

	'data.noDocuments':
		'No documents in this resource. This usually means the import has not finished yet, or no documents on this topic are available. Try again later.',
	'data.search': 'Search resources',
	'data.col.name': 'Name',
	'data.col.type': 'Type',
	'data.col.date': 'Date',
	'data.col.imported': 'Imported',
	'data.col.documents': 'Documents',
	'data.clearTypeFilter': 'Clear filter',

	'resourceType.debate': 'Debate',
	'resourceType.press_message': 'Press Release',
	'resourceType.person': 'Person',
	'resourceType.eu_cod': 'EU Codecision',
	'resourceType.cla': 'CLA',
	'resourceType.kleine_anfrage': 'Kleine Anfrage',

	'docType.speech': 'Debate in Bundestag',
	'docType.politician_bio': 'Person',
	'docType.eu_com_proposal': 'Commission Proposal',
	'docType.eu_ep_amendments_adopted': 'Adopted Amendments',
	'docType.eu_ep_cmt_opinion': 'Committee Opinion',
	'docType.eu_egp_briefing': 'EGP Internal Briefing',
	'docType.press_message': 'Parliamentary News "heute im bundestag"',
	'docType.kleine_anfrage': 'Kleine Anfrage',
	'docType.antwort_kleine_anfrage': 'Answer of the gonvernment',

	'docType.podcast_transscript': 'Podcast Transcript',
	'docType.generic_document': 'Document',

	'secondarySourceType.person': 'Person',
	'secondarySourceType.company': 'Organization',
	'secondarySourceType.ifg_request': 'IFG Request',
	'secondarySourceType.poll': 'Poll',
	'secondarySource.fetchedAt': 'Retrieved on {{date}}',

	'assets.header': 'Assets',
	'assets.placeholder': 'Generated images and files will show up here',
	'assets.untitled': 'Untitled asset',
	'assets.download': 'Download',
	'assets.kind.image': 'Image',
	'assets.kind.file': 'File',

	'screen.empty': 'No images to display yet',
	'screen.footer': 'All images are generated by exhibition visitors',
	'screen.scanToShare': 'Scan to view and share',
	'screen.unknownVisitor': 'Unknown',
	'screen.noDescription': 'Description not available',

	'images.title': 'Images',
	'images.empty': 'No images yet',
	'images.search': 'Search images',
	'images.visibility': 'Visibility',
	'images.visibilityOption.public': 'Public',
	'images.visibilityOption.private': 'Private',
	'images.selectAll': 'Select all',
	'images.selectedCount': '{{count}} selected',
	'images.clearSelection': 'Clear selection',
	'images.changeVisibility': 'Change visibility',
	'images.bulkVisibility.public': '{{count}} images will be marked public.',
	'images.bulkVisibility.private': '{{count}} images will be marked private.',

	'sources.header': 'Source Documents',
	'sources.headerDetail': 'Source Document',
	'sources.documents': 'Documents',
	'sources.documentLink': 'Document Link',
	'sources.content': 'Text',
	'sources.pdfPreview': 'PDF',
	'sources.metadata': 'Info',
	'sources.summary': 'Summary',
	'sources.details': 'Details',
	'sources.originalText': 'Original Text',
	'sources.placeholder':
		'Sources and context information will show up here, once you start the conversation',
	'sources.primarySources': 'Knowledge Base',
	'sources.secondarySources': 'Secondary Sources',
	'sources.openSource': 'Open Source',
	'sources.person.party': 'Party',
	'sources.person.born': 'Born',
	'sources.person.occupation': 'Occupation',
	'sources.person.education': 'Education',
	'sources.person.residence': 'Residence',
	'sources.person.fraction': 'Parliamentary group',
	'sources.person.parliament': 'Parliament',
	'sources.person.constituency': 'Constituency',
	'sources.person.mandateWon': 'Mandate',
	'sources.person.mandate.constituency': 'Direct mandate',
	'sources.person.mandate.list': 'Party list',
	'sources.person.mandate.movedUp': 'Moved up',
	'sources.person.sidejobs': 'Side activities',
	'sources.person.committees': 'Committee memberships',
	'sources.person.committeeRole.member': 'Member',
	'sources.person.committeeRole.alternateMember': 'Alternate member',
	'sources.person.committeeRole.chairperson': 'Chair',
	'sources.person.committeeRole.viceChairperson': 'Deputy chair',
	'sources.person.incomeLevel': 'Income level {{level}}',
	'sources.person.questionsReceived': 'Questions received',
	'sources.person.questionsAnswered': 'Questions answered',
	'sources.person.registerNumber': 'Register number',
	'sources.person.activityType': 'Activity',
	'sources.person.fieldsOfInterest': 'Fields of interest',
	'sources.person.financialExpenses': 'Lobbying expenses',
	'sources.company.registerNumber': 'Register number',
	'sources.company.legalForm': 'Legal form',
	'sources.company.active': 'Active',
	'sources.company.activityType': 'Activity',
	'sources.company.activityDescription': 'Description',
	'sources.company.fieldsOfInterest': 'Fields of interest',
	'sources.company.financialExpenses': 'Lobbying expenses',
	'sources.company.employeeFte': 'Lobby employees (FTE)',
	'sources.company.legalRepresentatives': 'Legal representatives',
	'sources.company.entrustedPersons': 'Entrusted persons',
	'sources.company.members': 'Members',
	'sources.company.memberships': 'Memberships',
	'sources.company.fundingSources': 'Funding sources',
	'sources.company.publicAllowances': 'Public allowances',
	'sources.company.legislativeProjects': 'Legislative projects',
	'sources.company.clientOrganizations': 'Client organizations',
	'sources.company.codexViolations': 'Codex violations',
	'sources.foi.status': 'Status',
	'sources.foi.resolution': 'Resolution',
	'sources.foi.refusalReason': 'Refusal reason',
	'sources.foi.authority': 'Authority',
	'sources.foi.jurisdiction': 'Jurisdiction',
	'sources.foi.filed': 'Filed',
	'sources.foi.dueDate': 'Due date',
	'sources.foi.lastMessage': 'Last message',
	'sources.foi.costs': 'Costs',
	'sources.poll.date': 'Date',
	'sources.poll.passed': 'Passed',
	'sources.poll.rejected': 'Rejected',
	'sources.poll.parliament': 'Parliament',
	'sources.poll.topics': 'Topics',
	'sources.description': 'Description',
	'sources.citedPassages': 'Cited Passages',
	'sources.copyrightNotice':
		'Only cited excerpts are shown here. Visit the source link to read the full content.',
	'sources.summaryNotAvailable': 'No summary available yet.',

	'settings.locale': 'Language',
	'settings.locale.en': 'English',
	'settings.locale.de': 'German',

	'settings.theme': 'Theme',
	'settings.theme.light': 'Light',
	'settings.theme.dark': 'Dark',
	'settings.theme.system': 'System Default',

	'settings.title': 'Settings',
	'settings.user.name': 'Name',
	'settings.user.firstName': 'First Name',
	'settings.user.lastName': 'Last Name',
	'settings.user.bio': 'What the agent needs to know about you',
	'settings.user.bioPlaceholder':
		'e.g. "I\'m a policy advisor specialising in housing law. Topics most relevant to me are tenancy law, social housing, and urban development."',
	'settings.user.email': 'Email',
	'settings.user.username': 'Username',
	'settings.user.defaultModel': 'Default Model',
	'settings.billing.title': 'Billing',
	'settings.billing.currentPlan': 'Current plan',
	'settings.deleteAccount': 'Delete Account',
	'settings.deleteAccount.title': 'Delete Your Account',
	'settings.deleteAccount.warning':
		'This action will schedule your account for deletion. All your data including conversations, settings, and personal information will be permanently removed.',
	'settings.deleteAccount.gracePeriod':
		'You have 30 days to change your mind. During this period, you can contact support to restore your account. After 30 days, all data will be permanently deleted.',
	'settings.deleteAccount.confirm': 'Yes, delete my account',
	'settings.deleteAccount.cancel': 'Cancel',
	'settings.deleteAccount.activeSubscription':
		'You have an active subscription. Please cancel your subscription before deleting your account.',

	'settings.instance.title': 'Instance Settings',
	'settings.instance.name': 'Instance Name',
	'settings.instance.primer': 'Primer',
	'settings.instance.primer.description.standard':
		"Behind the scenes, this is combined with fixed instructions covering role framing, the current date, response style, capability disclaimers (what the assistant can/cannot do), and, when enabled, tool usage and citation rules. Keep this primer focused on this instance's domain and voice.",
	'settings.instance.primer.description.antonio':
		"Behind the scenes, this is combined with fixed instructions covering role framing, the current date, and response guidelines, plus the generic antonio-mode flow: asking questions one at a time, confirming before generating, generating the image, collecting the user's name/email to save it, and saying goodbye. Keep this primer focused on what this project is about and which questions to ask. The flow around them is already handled.",
	'settings.instance.logo': 'Logo',
	'settings.instance.language': 'Language',
	'settings.instance.onboardingContent': 'Login Popup (Markdown, shown on first login)',
	'settings.instance.responseStyle': 'Response Style',
	'settings.instance.knowledgeBase': 'Knowledge Base Context',
	'settings.instance.featureFlags': 'Feature Flags',
	'settings.instance.billing.enabled': 'Enable Billing',
	'settings.instance.billing.enabled.description':
		'Enables billing and plan management pages for this instance.',
	'settings.instance.dailyBriefing': 'Daily Briefing',
	'settings.instance.webSearch': 'Web Search',
	'settings.instance.lobbyregister': 'Lobbyregister',
	'settings.instance.lobbyregister.description':
		'Lobbyregister search as secondary source. Registered lobbyists and their clients from the Bundestag lobby register.',
	'settings.instance.fragdenstaat': 'FragDenStaat',
	'settings.instance.fragdenstaat.description':
		'FragDenStaat search as secondary source. Freedom of information (IFG) requests to German authorities.',
	'settings.instance.abgeordnetenwatch': 'Abgeordnetenwatch',
	'settings.instance.abgeordnetenwatch.description':
		'Abgeordnetenwatch search as secondary source. Politician profiles, side jobs and roll-call votes.',
	'settings.instance.generalSettings': 'General Settings',
	'settings.instance.systemPrompt': 'System Prompt',
	'settings.instance.access': 'Access',
	'settings.instance.chatSuggestions': 'Chat Suggestions',
	'settings.instance.chatSuggestions.description':
		'Suggestions appear as clickable bubbles on the new chat page',
	'settings.instance.chatSuggestions.placeholder': 'Enter a suggestion...',
	'settings.instance.chatSuggestions.add': 'Add',
	'settings.instance.chatSuggestions.empty': 'No suggestions added yet',
	'settings.instance.knowledgeBase.flag': 'Knowledge Base',
	'settings.instance.knowledgeBase.flag.description':
		'Enables access to vector search, keyword search, and document retrieval tools.',
	'settings.instance.knowledgeBase.citationEngine': 'Citation Engine',
	'settings.instance.knowledgeBase.citationEngine.description':
		'Requires the agent to cite sources with exact quotes. Disable for assistants that do not need strict source attribution.',
	'settings.instance.dailyBriefing.description': 'Daily Briefing sub-page is visible.',
	'settings.instance.webSearch.description':
		'Web search as secondary source for supplementary information.',
	'settings.instance.webSearch.alwaysOn': 'Always On',
	'settings.instance.webSearch.alwaysOn.description':
		'Web search is always active. The user toggle in the chat input is hidden.',
	'settings.instance.queryClassification': 'Query Classification',
	'settings.instance.queryClassification.description':
		'Classifies queries before processing to skip retrieval and thinking for simple requests. Disable for models with adaptive thinking.',
	'settings.instance.blockedSearchDomains': 'Blocked Search Domains',
	'settings.instance.blockedSearchDomains.description':
		'Exclude these domains from web search results, separated by commas or line breaks. Leave empty to allow all domains.',
	'settings.instance.blockedSearchDomains.placeholder': 'e.g. wikipedia.org',
	'settings.instance.welcomeMessage': 'Welcome Message',
	'settings.instance.welcomeMessage.description':
		'Custom welcome message shown on the new chat page. Leave empty to use the default.',
	'settings.instance.defaultModel': 'Default Foundation Model',
	'settings.instance.attachments.enabled': 'Attachments in chat',
	'settings.instance.attachments.enabled.description':
		'Users can attach images, PDFs, Word, PowerPoint and Excel files and text files to their messages. Documents are read with Mistral OCR.',
	'settings.instance.ipUsageLimit.disabled': 'Disable per-IP usage limit',
	'settings.instance.ipUsageLimit.disabled.description':
		"Anonymous visitors on this instance's embeddable widget are normally capped once their IP address spends 500 credits. Disable this for trusted deployments (e.g. a supervised kiosk or event) where anonymous abuse isn't a concern.",
	'settings.instance.antonioMode.enabled': 'Antonio Instance',
	'settings.instance.antonioMode.enabled.description':
		'Turns this instance into an anonymous, Antonio-style guided chat experience with a restricted tool set (buttons/inputs, image generation) instead of the regular knowledge-base chat. Cannot be changed after the instance is created.',
	'settings.instance.antonio.evalFunnel': 'Eval Funnel',
	'settings.instance.autoAuth': 'Allow unauthenticated chat',
	'settings.instance.autoAuth.description':
		'Anyone with the link can chat without logging in. Useful for handing out a link at an event. Turn off at any time to immediately block new visitors.',
	'settings.instance.antonioSteps.description':
		'Questions visitors answer by picking options before the chat starts. The AI gets the picks as facts.',
	'settings.instance.antonioSteps.question': 'Question',
	'settings.instance.antonioSteps.selectionMode': 'Selection',
	'settings.instance.antonioSteps.singleSelect': 'Single choice',
	'settings.instance.antonioSteps.multiSelect': 'Multiple choice',
	'settings.instance.antonioSteps.maxSelect': 'How many options a visitor may pick',
	'settings.instance.antonioSteps.optionLabel': 'Option',
	'settings.instance.antonioSteps.promptContext': 'Background for the AI (not shown to visitors)',
	'settings.instance.antonioSteps.addOption': 'Add option',
	'settings.instance.antonioSteps.removeOption': 'Remove option',
	'settings.instance.antonioSteps.addStep': 'Add step',
	'settings.instance.antonioSteps.removeStep': 'Remove step',
	'settings.instance.antonioSteps.moveUp': 'Move up',
	'settings.instance.antonioSteps.moveDown': 'Move down',
	'settings.instance.referenceImages': 'Reference images',
	'settings.instance.referenceImages.description':
		"Photos of real places the generated image is based on. A visitor's own image replaces them.",
	'settings.instance.referenceImages.mode': 'Number of Reference Images',
	'settings.instance.referenceImages.mode.single': 'Single Reference Image',
	'settings.instance.referenceImages.mode.single.description':
		'Every generated image is based on it. Visitors do not pick anything.',
	'settings.instance.referenceImages.mode.single.deletesOthers':
		'Saving deletes the other {{n}} reference images. Switch back to multiple to keep them.',
	'settings.instance.referenceImages.mode.multiple': 'Multiple Reference Images',
	'settings.instance.referenceImages.mode.multiple.description':
		'Adds a choice step before the interview, where visitors pick one of them by name.',
	'settings.instance.referenceImages.mode.multiple.tooFew':
		'Add at least two, or switch to a single reference image.',
	'settings.instance.referenceImages.mode.hint':
		'Want some variety without a choice step? Use a single reference image with several photos. Each conversation gets one of them at random.',
	'settings.instance.referenceImages.name':
		'Name (visitors pick by it, the gallery shows it as the location)',
	'settings.instance.referenceImages.photos': 'Photos (one is picked at random per conversation)',
	'settings.instance.referenceImages.photo': 'Photo {{n}}',
	'settings.instance.referenceImages.addPhoto': 'Add photo',
	'settings.instance.referenceImages.removePhoto': 'Remove photo',
	'settings.instance.referenceImages.add': 'Add reference image',
	'settings.instance.referenceImages.remove': 'Remove reference image',

	'settings.instance.antonioFunnel.description':
		'Everything a visitor goes through, from top to bottom. Switch steps on or off, and each preview shows what visitors will see.',
	'settings.instance.antonioFunnel.welcome': 'Welcome',
	'settings.instance.antonioFunnel.welcome.description': 'The first thing visitors see.',
	'settings.instance.antonioFunnel.welcomeDisplay': 'Show Welcome Message As',
	'settings.instance.antonioFunnel.welcomeDisplay.message': 'Chat Message',
	'settings.instance.antonioFunnel.welcomeDisplay.screen': 'Start Screen',
	'settings.instance.antonioFunnel.welcomeDisplay.description':
		'As a chat message, the chat starts right away with the welcome message. On a start screen, visitors read it first and tap Start to begin.',
	'settings.instance.antonioFunnel.referenceImageChoice': 'Reference Image Choice',
	'settings.instance.antonioFunnel.referenceImageChoice.description':
		'Visitors pick one of the reference images. The assistant asks for it, so describe the question in the primer.',
	'settings.instance.antonioFunnel.choiceSteps': 'Choice Steps',
	'settings.instance.antonioFunnel.choiceStep': 'Choice {{n}}',
	'settings.instance.antonioFunnel.editStep': 'Edit',
	'settings.instance.antonioFunnel.doneEditing': 'Done',
	'settings.instance.antonioFunnel.interview': 'Interview',
	'settings.instance.antonioFunnel.interview.description':
		'The assistant asks the questions from the primer, one at a time, then sums up what it understood.',
	'settings.instance.antonioFunnel.interview.editPrimer': 'Edit primer',
	'settings.instance.antonioFunnel.generate': 'Image Generation',
	'settings.instance.antonioFunnel.generate.description':
		"The assistant writes an image prompt from the conversation and edits a reference image with it: the one the visitor picked, if there are several. A visitor's own image replaces it.",
	'settings.instance.antonioFunnel.end': 'End',
	'settings.instance.antonioFunnel.end.description':
		'What visitors can do once their image is published.',
	'settings.instance.antonioFunnel.end.gallerySettings': 'Gallery settings',
	'settings.instance.antonioFunnel.galleryLink': 'Link to the Image in the Gallery',
	'settings.instance.antonioFunnel.galleryLink.description':
		'Shows a button that opens the published image in the public gallery.',
	'settings.instance.antonioFunnel.galleryLink.galleryDisabled':
		'The gallery is not enabled, so visitors do not see this button yet.',
	'settings.instance.antonioFunnel.feedback': 'Ask for Feedback',
	'settings.instance.antonioFunnel.feedback.description':
		'Shows a feedback button that leads to the selected eval funnel. Not shown in the live chat yet.',

	'settings.instance.antonioChat.autoReset': 'Auto Reset',
	'settings.instance.antonioChat.autoReset.description':
		'If checked, the chat session resets automatically after a few minutes of inactivity.',
	'settings.instance.antonioChat.allowChanges': 'Allow Changes',
	'settings.instance.antonioChat.allowChanges.description':
		'If checked, visitors can add something before the image is generated and ask for changes instead of saving it. If unchecked, all "Not yet" buttons are hidden, so every visitor gets exactly one image.',
	'settings.instance.antonioChat.showEmailInput': 'Show Email Input',
	'settings.instance.antonioChat.showEmailInput.description':
		'If checked, the assistant may ask users for their email address during the conversation.',
	'settings.instance.antonioChat.showNewsletterCheckbox': 'Show Newsletter Checkbox',
	'settings.instance.antonioChat.showNewsletterCheckbox.description':
		'If checked, users are shown a newsletter opt-in checkbox when providing their email address.',
	'settings.instance.antonioChat.collectContactInfo': 'Collect Contact Info',
	'settings.instance.antonioChat.collectContactInfo.description':
		"If checked, the assistant asks for the user's name (and email, if enabled) before publishing their image. If unchecked, no personal info is collected; the assistant instead asks the user to confirm the image is ready to be published.",
	'settings.instance.antonioChat.collectImage': 'Ask for an Image',
	'settings.instance.antonioChat.collectImage.description':
		"If checked, the assistant asks each visitor for their own image before generating, and uses that image as the reference instead of the instance's reference image. Visitors can also continue without one.",
	'settings.instance.antonioChat.userProvidedImageGuidance': 'Image Guidance',
	'settings.instance.antonioChat.userProvidedImageGuidance.description':
		'Tells the assistant what visitors are uploading, for example that it is a selfie whose likeness has to be preserved. This is added to the general rules for editing an unseen image, which always apply. Leave empty if the upload needs no special handling.',
	'settings.instance.antonioChat.imageFormat': 'Image Format',
	'settings.instance.antonioChat.imageFormat.description':
		'Aspect ratio of the generated image. Portrait and landscape use the DIN A ratio, so they print to A6 or A5 without cropping.',
	'settings.instance.antonioChat.imageFormat.square': 'Square',
	'settings.instance.antonioChat.imageFormat.portrait': 'Portrait',
	'settings.instance.antonioChat.imageFormat.landscape': 'Landscape',
	'settings.instance.antonioChat.imageModel': 'Image Model',
	'settings.instance.antonioChat.imageResolution': 'Resolution',
	'settings.instance.antonioChat.imageResolution.description':
		'Flux 3 charges a flat price per image, set by the resolution. 1K is about 1 megapixel, enough for the web. 2K is about 4 megapixels for sharp prints and costs about twice as much. Flux 3 renders portrait and landscape at 5:7, about 1% off the DIN A ratio, so prints lose a thin edge.',
	'settings.instance.antonioChat.aiLabel': 'AI Label on Images',
	'settings.instance.antonioChat.aiLabel.description':
		'Stamps "AI generated with" and the assistant name onto the bottom right corner of every new image, in the configured language, and tags the file as AI generated in its metadata. Images created before stay as they are.',
	'settings.instance.antonioChat.avatar': 'Avatar',
	'settings.instance.antonioChat.assistantName': 'Assistant Name',
	'settings.instance.antonioChat.assistantName.description':
		'The name shown to users in the chat (e.g. "Chat with Antonio"). Leave blank to use the default, "Antonio".',

	'settings.instance.gallery.enabled': 'Enable Gallery',
	'settings.instance.gallery.enabled.description':
		'Makes the gallery publicly reachable via its direct link, without listing it on the public gallery page.',
	'settings.instance.gallery.listed': 'List on Gallery Page',
	'settings.instance.gallery.listed.description':
		'Also shows this exhibition on the public gallery page, in addition to being reachable via its direct link.',
	'settings.instance.gallery.online': 'Online Exhibition',
	'settings.instance.gallery.online.description':
		'Marks this exhibition as online-only (no physical venue), shown in a separate section on the public gallery page.',
	'settings.instance.gallery.link': 'Link',
	'settings.instance.gallery.venue': 'Venue',
	'settings.instance.gallery.start': 'Start',
	'settings.instance.gallery.end': 'End',
	'settings.instance.gallery.description': 'Description',
	'settings.instance.gallery.logo': 'Logo',

	'antonio.chatHeader': 'Chat with {{name}}',
	'antonio.avatarAlt': '{{name}} avatar',
	'antonio.onboarding.start': 'Start',
	'antonio.contact.namePlaceholder': 'Your name',
	'antonio.contact.emailPlaceholder': 'Email address (optional)',
	'antonio.contact.newsletterOptIn':
		'Please also send me occasional news about further AI projects from you (newsletter).',
	'antonio.contact.submitted.name': "I've entered my name.",
	'antonio.contact.submitted.nameEmail': "I've entered my name and email address.",
	'antonio.startOver': 'Start Over',
	'antonio.generateConfirm.yes.label': 'Yes, generate it!',
	'antonio.generateConfirm.yes.value': 'Yes, please generate the image now.',
	'antonio.generateConfirm.no.label': 'Not yet',
	'antonio.generateConfirm.no.value': "Not yet, I'd like to add something first.",
	'antonio.image.choose': 'Take or upload an image',
	'antonio.image.change': 'Choose a different image',
	'antonio.image.use': 'Use this image',
	'antonio.image.skip': 'Continue without an image',
	'antonio.image.hint': 'Your upload is only used to generate the image and is deleted afterwards.',
	'antonio.image.uploadError': 'The image could not be uploaded. Please try again.',
	'antonio.publishConfirm.yes.label': 'Save & publish',
	'antonio.publishConfirm.yes.value': 'Yes, please save and publish this image.',
	'antonio.publishConfirm.no.label': 'Make changes',
	'antonio.publishConfirm.no.value': "I'd like to make some changes to the image first.",
	'antonio.generatingImage': "I'm generating the image now, this can take a few seconds...",
	'antonio.viewInGallery': 'View Image',
	'antonio.chat.retryButton': 'Retry',
	'antonio.choice.confirm': 'Continue',
	'antonio.choice.hint': 'Pick up to {{max}}',

	'settings.instance.nav.header': 'Admin Settings',
	'settings.instance.nav.back': 'Back',
	'settings.instance.nav.instanceSection': 'Instance Settings',
	'settings.instance.nav.general': 'General',
	'settings.instance.nav.knowledgeBase': 'Knowledge Base',
	'settings.instance.nav.secondarySources': 'Secondary Sources',
	'settings.instance.nav.queryClassification': 'Query Classification',
	'settings.instance.nav.imageGeneration': 'Image Generation',
	'settings.instance.nav.antonioAssistant': 'Assistant',
	'settings.instance.nav.antonioFunnel': 'Funnel',
	'settings.instance.nav.antonioReferenceImages': 'Reference Images',
	'settings.instance.nav.antonioGallery': 'Gallery',
	'settings.instance.nav.chatSuggestions': 'Chat Suggestions',
	'settings.instance.nav.apiKeys': 'API Keys',
	'settings.instance.nav.billing': 'Billing',
	'settings.instance.nav.systemHealth': 'System Health',
	'settings.instance.nav.news': 'News',
	'settings.instance.nav.antonioSection': 'Antonio',
	'settings.instance.nav.featuresSection': 'Features',
	'settings.instance.nav.systemSection': 'System',
	'settings.instance.unsavedChanges': 'Unsaved changes',
	'settings.instance.unsavedChanges.title': 'Discard changes?',
	'settings.instance.unsavedChanges.message':
		'You have unsaved changes on this page. They will be lost if you leave it.',
	'settings.instance.unsavedChanges.discard': 'Discard',

	'settings.instance.imageGeneration.enabled': 'Enable image generation',
	'settings.instance.imageGeneration.enabled.description':
		'Allows the chat assistant to generate images when asked, using the generate_image tool.',
	'settings.instance.imageGeneration.model': 'Image model',

	'news.center': 'News Center',
	'news.noItems': 'No news',
	'news.new': 'New item',
	'news.title': 'Title',
	'news.body': 'Body',
	'news.ctaLabel': 'Button label',
	'news.ctaHref': 'Button link',
	'news.showFrom': 'Show from',
	'news.showUntil': 'Show until',
	'news.edit': 'Edit item',
	'news.delete.confirm': 'Delete news item',
	'news.delete.question': 'Do you really want to delete this news item?',

	'settings.instance.systemHealth.basic': 'Basic Health Check',
	'settings.instance.systemHealth.basic.description':
		'Checks if the RAG service and its database connection are up. Same check as the automatic monitoring.',
	'settings.instance.systemHealth.extended': 'Extended Health Check',
	'settings.instance.systemHealth.extended.description':
		'Runs a test request against every available AI model plus the embedding and reranking service. This makes real model calls and can take up to a minute.',
	'settings.instance.systemHealth.run': 'Run check',
	'settings.instance.systemHealth.status.ok': 'All checks passed',
	'settings.instance.systemHealth.status.degraded': 'Some checks failed',

	'settings.instance.defaultClassification': 'Default Classification',
	'settings.instance.defaultClassification.description':
		'Behavior when query classification is disabled. These settings define how every query is handled.',
	'settings.instance.defaultClassification.enableThinking': 'Enable Thinking',
	'settings.instance.defaultClassification.hideThinking': 'Hide Thinking',
	'settings.instance.defaultClassification.enableTools': 'Enable Tools',
	'settings.instance.defaultClassification.temperature': 'Temperature',
	'settings.instance.defaultClassification.maxIterations': 'Max Iterations',

	'instance.create.title': 'New Instance',
	'instance.create.name': 'Instance Name',
	'instance.create.slug': 'Slug (URL identifier)',
	'instance.create.language': 'Language',
	'instance.create.type': 'Instance Type',
	'instance.create.type.standard': 'Standard',
	'instance.create.type.standard.description':
		'Regular authenticated chat with the full configurable tool set.',
	'instance.create.type.antonio': 'Antonio',
	'instance.create.type.antonio.description':
		'Anonymous, Antonio-style guided chat experience with a restricted tool set (buttons/inputs, image generation) instead of the regular knowledge-base chat. Cannot be changed after the instance is created.',
	'instance.create.submit': 'Create Instance',
	'instance.duplicate.title': 'Duplicate Instance',
	'instance.duplicate.description':
		'Creates a new instance with the saved settings of this one, including copies of its reference images and logo. Users, API keys, conversations and images stay with the original. The copy starts with the gallery and unauthenticated chat turned off.',
	'instance.duplicate.copyName': '{{name}} (copy)',
	'instance.duplicate.submit': 'Duplicate',
	'instance.picker.title': 'Switch Instance',
	'instance.picker.search': 'Search by name or slug',
	'instance.picker.empty': 'No instance matches your search.',
	'instance.picker.galleryLive': 'Gallery live',
	'instance.picker.created': 'Created {{date}}',

	'apiKeys.title': 'API Keys',
	'apiKeys.createNew': 'Create New Key',
	'apiKeys.noKeys': 'No API keys yet. Create one to get started.',
	'apiKeys.active': 'Active',
	'apiKeys.inactive': 'Inactive',
	'apiKeys.created': 'Created',
	'apiKeys.lastUsed': 'Last used',
	'apiKeys.expires': 'Expires',
	'apiKeys.neverExpires': 'Never expires',
	'apiKeys.requests': 'requests',
	'apiKeys.createdBy': 'Owner',
	'apiKeys.anonymousConversations': 'Anonymous Conversations',
	'apiKeys.deleteConfirm': 'Are you sure you want to delete the API key "{{name}}"?',

	'sharedLinks.title': 'Shared Links',
	'sharedLinks.createNew': 'Create Shared Link',
	'sharedLinks.noLinks': 'No shared links yet. Create one to get started.',
	'sharedLinks.deleteConfirm': 'Are you sure you want to delete this shared link?',
	'sharedLinks.create.title': 'Create Shared Link',
	'sharedLinks.create.generating': 'Generating shared link...',

	'apiKeys.create.title': 'Create API Key',
	'apiKeys.create.keyName': 'Key Name',
	'apiKeys.create.keyType': 'Key Type',
	'apiKeys.create.keyType.widget': 'Widget',
	'apiKeys.create.keyType.sharedLink': 'Shared Link',
	'apiKeys.create.keyType.api': 'API / Integration',
	'apiKeys.create.allowedOrigins': 'Allowed Origins (comma-separated)',
	'apiKeys.create.validityPeriod': 'Validity Period',
	'apiKeys.create.neverExpires': 'Never expires',
	'apiKeys.create.days': '{{count}} days',
	'apiKeys.create.year': '1 year',
	'apiKeys.create.anonymousConversations': 'Anonymous Conversations',
	'apiKeys.create.anonymousConversationsHelp':
		"Conversations will have no owner and won't appear in the creator's conversation list.",
	'apiKeys.create.submit': 'Create Key',
	'apiKeys.create.warning':
		"Make sure to copy your API key now. You won't be able to see it again!",
	'apiKeys.create.copyToClipboard': 'Copy to Clipboard',
	'apiKeys.create.done': 'Done',
	'apiKeys.create.sharedLinkSuccess': 'Share this link with others:',

	'onboarding.title': 'Welcome!',
	'onboarding.getStarted': 'Get Started',
	'onboarding.showDialog': 'Show welcome dialog',

	'plan.free': 'Free',
	'plan.essential': 'Essential',
	'plan.pro': 'Pro',
	'plan.conversations': '{{current}}/{{max}} conversations',
	'plan.conversationsUnlimited': 'Unlimited conversations',
	'plan.usageWarning': '{{percent}}% of monthly quota used',
	'plan.usingExtraCredits': 'Using extra credits',
	'plan.quotaExhausted': 'Quota used up',
	'plan.extraCreditsInUse':
		'Included quota used up. Extra credits being used ({{count}} remaining)',
	'plan.creditsExhausted': 'All credits used — upgrade to continue',
	'plan.upgrade': 'Upgrade',
	'plan.upgrade.title': 'Manage Plan',
	'plan.upgrade.description':
		'Get more conversations and messages per conversation by upgrading your plan.',
	'plan.upgrade.currentPlan': 'Current Plan',
	'plan.upgrade.features': 'Features',
	'plan.upgrade.conversationsLimit': '{{count}} conversations',
	'plan.upgrade.conversationsUnlimited': 'Unlimited conversations',
	'plan.upgrade.messagesLimit': '{{count}} messages per conversation',
	'plan.upgrade.messagesUnlimited': 'Unlimited messages per conversation',
	'plan.upgrade.essentialDescription': 'Essentials for monitoring and parliamentary research',
	'plan.upgrade.proDescription': 'The complete ParlamentAI experience for power users',
	'plan.upgrade.higherUsageLimitsThanEssential': 'Higher usage limits than Essential',
	'billing.checkout.taxOnBillingDetails': 'Tax calculated based on your billing details',
	'plan.upgrade.earlyAdopterTitle': 'Early Adopter Bonus',
	'plan.upgrade.earlyAdopterDescription':
		'As a reward for joining Botbakery early, double your limits for free!',
	'plan.upgrade.claimBonus': 'Claim Bonus',
	'plan.upgrade.comingSoon': 'Coming soon',
	'plan.upgrade.contact': 'Contact Us',
	'plan.upgrade.contactDescription': 'Interested in upgrading? Get in touch with us.',
	'billing.upgradePlan': 'Upgrade Plan',
	'billing.upgrade': 'Upgrade',
	'billing.upgrade.trialHint': 'Try for free',
	'billing.upgrade.customAlternativeTitle': 'Need a custom instance?',
	'billing.upgrade.customAlternativeBody':
		"Get in touch and we'll set up ParlamentAI to fit your organization.",
	'billing.manageBilling': 'Manage Billing',
	'billing.monthly': 'Pay Monthly',
	'billing.yearly': 'Pay Yearly',
	'billing.priceFrom': 'from',
	'billing.perMonth': 'month',
	'billing.perYear': 'year',
	'billing.savePercent': 'Save {{percent}}%',
	'billing.priceNA': 'n/a',
	'billing.vatDisclaimer': 'All prices excl. 19% VAT',
	'billing.compareAbos': 'Compare full plan details',
	'billing.renewsOn': 'Renews on {{date}}',
	'billing.cancelsOn': 'Cancels on {{date}}',
	'billing.trialEndsOn':
		'Trial ends {{date}}. You will then be charged unless you cancel before then.',
	'billing.status.active': 'Active',
	'billing.status.trialing': 'Free trial',
	'billing.status.cancelled': 'Cancelled',
	'billing.nonBilled.info': 'You are currently not being billed for this plan.',
	'billing.customBilled.info': 'Your plan is billed by invoice.',
	'billing.upgrade.successMessage': 'Upgrade successful! Welcome to Pro.',
	'billing.upgrade.canceledMessage': 'Checkout canceled. Your plan is unchanged.',
	'billing.upgrade.creditsAlternativeTitle': "Don't need a subscription?",
	'billing.upgrade.creditsAlternativeBody':
		'Buy credits and pay only for what you use, with no monthly commitment.',
	'billing.upgrade.buyCreditsInstead': 'Buy credits',
	'billing.form.title': 'Payment Method',
	'billing.form.subscribe': 'Subscribe',
	'billing.form.savePaymentMethod': 'Save Payment Method',
	'billing.form.processing': 'Processing…',
	'billing.form.intentError': 'Could not create payment session. Please try again.',
	'billing.form.stripeLoadError': 'Could not load payment form. Please try again.',
	'billing.form.genericError': 'Payment failed. Please try again.',
	'billing.form.email': 'Billing email',
	'billing.form.billingAddress': 'Billing address',
	'billing.form.region': 'Country',
	'billing.form.addressLine1': 'Street + House number',
	'billing.form.postalCode': 'Postal code',
	'billing.form.city': 'City',
	'billing.form.vatId': 'VAT ID (optional)',
	'billing.form.vatIdPlaceholder': 'e.g. DE123456789',
	'billing.form.vatIdInvalid': 'Invalid VAT ID format.',
	'billing.form.addressIncomplete': 'Please fill in your billing address.',
	'billing.form.paymentMethodSaved': 'Payment method saved.',
	'billing.addPaymentMethod': 'Add Payment Method',
	'billing.updatePaymentMethod': 'Update Payment Method',
	'billing.details.title': 'Billing Details',
	'billing.details.name': 'Full name / company name',
	'billing.details.save': 'Save',
	'billing.details.saving': 'Saving…',
	'billing.details.saved': 'Billing details saved.',
	'billing.details.error': 'Could not save billing details. Please try again.',
	'billing.details.addressIncomplete': 'Please fill in your billing address.',
	'billing.details.missingRequired': 'Please enter your name and billing email.',
	'billing.payment.title': 'Payment Method',
	'billing.payment.expires': 'Expires {{date}}',
	'billing.payment.changeCard': 'Change card',
	'billing.payment.saveCard': 'Save card',
	'billing.payment.saving': 'Saving…',
	'billing.payment.saved': 'Payment method saved.',
	'billing.payment.stripeLoadError': 'Could not load payment form. Please try again.',
	'billing.payment.intentError': 'Could not create payment session. Please try again.',
	'billing.payment.genericError': 'Could not save card. Please try again.',
	'billing.checkout.title': 'Checkout',
	'billing.checkout.subscribe': 'Subscribe with obligation to pay',
	'billing.checkout.subscribing': 'Subscribing…',
	'billing.checkout.subscribeError': 'Could not complete subscription. Please try again.',
	'billing.checkout.noPaymentMethod': 'Add a payment method to subscribe.',
	'billing.checkout.paymentMethodReady': 'Payment method ready.',
	'billing.checkout.orderSummary': 'Order Summary',
	'billing.checkout.net': 'Subtotal',
	'billing.checkout.vatAmount': 'VAT (19%)',
	'billing.checkout.total': 'Total',
	'billing.checkout.totalPerMonth': 'Total per month',
	'billing.checkout.totalPerYear': 'Total per year',
	'billing.checkout.dueToday': 'Due today',
	'billing.checkout.startsImmediately': 'Subscription starts immediately',
	'billing.checkout.nextMonthlyCharge': 'Next monthly charge: {{date}}',
	'billing.checkout.nextAnnualCharge': 'Next annual charge: {{date}}',
	'billing.checkout.cancelAnytime': 'You can cancel your plan anytime.',
	'billing.checkout.acceptTermsBefore':
		'By clicking the button below, you confirm that you agree to our ',
	'billing.checkout.acceptTermsBetween': ' and ',
	'billing.checkout.acceptTermsAfter': '.',
	'billing.checkout.upgrade': 'Upgrade with obligation to pay',
	'billing.checkout.upgradeError': 'Could not upgrade subscription. Please try again.',
	'billing.checkout.startTrial': 'Start free trial',
	'billing.checkout.trialFineprint':
		'Your 7-day free trial starts today. You will be charged {{amount}} on {{date}} unless you cancel before then.',
	'billing.checkout.alreadyOnPlan':
		'You are trying to subscribe to the {{selectedPlan}} plan, but you are already on the {{currentPlan}} plan.',
	'billing.checkout.proratedChargeNew': 'New plan (prorated)',
	'billing.checkout.proratedCreditOld': 'Previous plan credit',
	'billing.checkout.creditBalance': 'Credit toward next invoice',
	'billing.checkout.proratedNote':
		'A prorated amount for the remaining days in your billing period will be charged immediately.',
	'billing.checkout.successTitle': 'Subscription active',
	'billing.checkout.successMessage': 'You have successfully subscribed to ParlamentAI {{plan}}.',
	'billing.checkout.successTitleTrial': 'Free trial started',
	'billing.checkout.successMessageTrial':
		'Your 7-day free trial has started. Enjoy full access to ParlamentAI {{plan}}.',
	'billing.checkout.successCta': "Let's go",
	'billing.checkout.successNextSteps': 'What you can do now:',
	'billing.checkout.successNewChat': 'Start a new chat',
	'billing.checkout.successNewChatDesc': 'Ask questions about bills, debates, and proceedings',
	'billing.checkout.successSetupBriefing': 'Set up a personalized briefing',
	'billing.checkout.successSetupBriefingDesc': 'Get daily updates on the topics that matter to you',
	'billing.checkout.processingTitle': 'Upgrade being processed',
	'billing.checkout.processingMessage': 'Your plan upgrade is being processed…',
	'billing.checkout.processingCta': 'Reload',
	'billing.checkout.timeoutTitle': 'Still processing…',
	'billing.checkout.timeoutMessage':
		'Your purchase is taking a bit longer than expected. Credits will appear in your account shortly — you can close this page.',
	'settings.user.nav.general': 'General',
	'settings.user.nav.billing': 'Billing',
	'settings.user.nav.usage': 'Usage',
	'settings.user.nav.integrations': 'Integrations',
	'settings.user.nav.communications': 'Communications',
	'settings.user.communications.description':
		'Choose which emails you would like to receive from us.',
	'settings.user.communications.newsletter': 'Botbakery Newsletter',
	'settings.user.communications.newsletter.description':
		'News and updates about Botbakery and our projects, including parlament.ai, new tools, and what we are working on.',
	'settings.user.communications.productUpdates': 'Product Updates',
	'settings.user.communications.productUpdates.description':
		'Release notes and new features for the platform.',
	'settings.user.integrations.intro':
		"Connect {{instanceName}} with your existing tools and workflows. Integrations require a Pro plan, and API calls always consume usage credits, independent of your plan's included quota.",
	'settings.user.integrations.noCredits':
		"You have no usage credits. API calls always consume credits from your balance, separate from your plan's included quota.",
	'settings.user.integrations.info':
		'Do you want to integrate {{instanceName}} with {{name}}? Get in touch with us.',
	'settings.user.integrations.requestSetup': 'Request setup',
	'settings.user.integrations.email.subject': 'Integration request: {{name}}',
	'settings.user.integrations.email.body':
		"Hi,\n\nI'd like to request the setup of a {{name}} integration for my organisation.\n\nPlease get in touch to discuss the next steps.\n\nBest regards",
	'settings.user.integrations.about.title': 'Agent2Agent (A2A) access',
	'settings.user.integrations.about.description':
		"{{instanceName}} exposes an Agent2Agent (A2A) compliant agent card, so it works with any A2A-compatible client, not just the ones listed below. Point your client's agent card field at the URL below, or use the endpoint URL if it asks for one instead.",
	'settings.user.integrations.agentCardUrl': 'Agent card URL',
	'settings.user.integrations.agentEndpointUrl': 'Agent endpoint URL',
	'settings.user.integrations.copilot.name': 'Microsoft Copilot',
	'settings.user.integrations.copilot.description':
		'Connect {{instanceName}} as a custom AI agent in Microsoft Copilot Studio.',
	'settings.user.integrations.copilot.step1':
		'In Copilot Studio, open your agent and go to Agents → Add an agent → Connect to an external agent → Agent2Agent.',
	'settings.user.integrations.copilot.step2':
		'Enter the agent endpoint URL from above (not the agent card URL) into the endpoint field.',
	'settings.user.integrations.copilot.step3':
		"Copilot Studio tries to auto-fill the agent name and description from the agent card. If it can't, enter them manually.",
	'settings.user.integrations.copilot.step4':
		'Choose or create a connection, set its authentication to "API Key", and enter a key from the API Keys section below.',
	'settings.user.integrations.copilot.step5':
		'Select "Add and configure". {{instanceName}} will now be available as an agent in your Microsoft 365 Copilot.',
	'settings.user.integrations.langdock.name': 'Langdock',
	'settings.user.integrations.langdock.description':
		'Connect {{instanceName}} as a custom AI agent in your Langdock workspace.',
	'settings.user.integrations.langdock.step1': 'Open Integrations in the Langdock left menu.',
	'settings.user.integrations.langdock.step2':
		'Click "Add integration" → "Start from scratch", then select "Connect Remote Agent (A2A)".',
	'settings.user.integrations.langdock.step3':
		'Paste the agent card URL from above into the Agent Card URL field. Set Authentication method to "API Key" and enter a key from the API Keys section below.',
	'settings.user.integrations.langdock.step4':
		'Click "Create". {{instanceName}} is now available as an AI agent in your Langdock workspace.',
	'settings.user.integrations.apiKeys.title': 'API Keys',
	'settings.user.integrations.apiKeys.description':
		'Create API keys to authenticate integrations with {{instanceName}}. Each integration should have its own key.',
	'settings.user.integrations.apiKeys.noKeys': 'No API keys yet. Create one to get started.',
	'settings.user.integrations.setupGuide': 'Setup guides',
	'settings.user.integrations.help.title': 'Need help?',
	'settings.user.integrations.help.description':
		'Have questions about setting up an integration or need a custom solution? We are happy to help.',
	'settings.user.integrations.help.cta': 'Contact us',
	'settings.user.billing.title': 'Billing',
	'settings.user.usage.title': 'Usage',
	'settings.user.usage.comingSoon': 'Usage statistics coming soon.',
	'settings.user.usage.quotas': 'Quotas',
	'settings.user.usage.chatUsage': 'Chat',
	'settings.user.usage.briefings': 'Briefing Subscriptions',
	'settings.user.usage.used': '{{percent}}% used',
	'settings.user.usage.briefingsCount': '{{used}} / {{max}} active',
	'settings.user.usage.briefingsOnlyActive': 'Only active briefings count',
	'settings.user.usage.briefingsNoPlan': 'Requires at least the Essential plan',
	'settings.user.usage.unlimited': 'Unlimited',
	'settings.user.usage.resetsOn': 'Resets on {{date}}',
	'settings.user.usage.resetsDaily': 'Resets daily',
	'settings.user.usage.grantBalance': 'Additional credits',
	'settings.user.usage.grantBalanceIntro':
		"Additional credits are only used once your plan's included quota is used up.",
	'settings.user.usage.grantBalanceEmpty': 'You have no additional credits.',
	'settings.user.usage.grantBalancePurchaseBefore': 'Need more credits? Reach out to us at',
	'settings.user.usage.grantBalancePurchaseAfter': '— self-service purchasing is coming soon.',
	'settings.user.usage.grantBalanceAvailable': 'Available credits',
	'settings.user.usage.statusWarn':
		"You've used {{percent}}% of your monthly quota. Once you reach 100%, extra credits will be used automatically if you have any.",
	'settings.user.usage.statusExtraCredits':
		'Your included monthly quota is used up. Extra credits are now being consumed ({{count}} remaining). They will be used automatically until depleted.',
	'settings.user.usage.statusExhausted':
		'Your monthly quota is fully used up and you have no extra credits left. You cannot start new chats until your quota resets or you upgrade your plan.',
	'settings.user.usage.grantHistory': 'Grant history',
	'settings.user.usage.grantHistoryDate': 'Date',
	'settings.user.usage.grantHistoryAmount': 'Amount',
	'settings.user.usage.grantHistoryNote': 'Note',
	'common.cancel': 'Cancel',
	'billing.pastDue.warning': 'Payment issue detected.',
	'billing.pastDue.contact':
		"We've noticed an issue with your payment and will be in touch shortly.",
	'billing.pastDue.retry': 'Retry payment',
	'billing.pastDue.retryError': 'Could not retry payment. Please try again.',
	'billing.canceledGracePeriod': 'Your subscription ends on {{date}}. You still have Pro access.',
	'billing.canceledGracePeriodNoDate':
		'Your subscription has been canceled. You still have Pro access until the end of the billing period.',
	'billing.managePlan': 'Manage Plan',
	'billing.earlyAccess.title': 'Billing coming soon',
	'billing.earlyAccess.description':
		'We are currently working on billing and plan management. You will be able to upgrade your plan here soon.',
	'billing.invoices.title': 'Invoices',
	'billing.invoices.loading': 'Loading invoices…',
	'billing.invoices.empty': 'No invoices yet.',
	'billing.invoices.download': 'Download',
	'billing.invoices.col.date': 'Date',
	'billing.invoices.col.number': 'Invoice Number',
	'billing.invoices.col.total': 'Total',
	'billing.invoices.col.status': 'Status',
	'billing.invoices.col.download': 'Download',
	'billing.invoices.status.draft': 'Draft',
	'billing.invoices.status.open': 'Open',
	'billing.invoices.status.paid': 'Paid',
	'billing.invoices.status.uncollectible': 'Uncollectible',
	'billing.invoices.status.void': 'Void',
	'billing.cancel.title': 'Cancel Subscription',
	'billing.cancel.description':
		'Your plan stays active until the end of the current billing period. After that, you will be downgraded to the Free plan.',
	'billing.cancel.confirm': 'Cancel Subscription',
	'billing.cancel.keep': 'Keep subscription',
	'billing.cancel.success': 'Your subscription has been canceled and will not renew.',
	'billing.cancel.error': 'Could not cancel subscription. Please try again.',
	'billing.cancel.feedback': 'Before you go — tell us what we can improve:',
	'billing.cancel.feedbackLink': 'Send feedback',
	'billing.reactivate': 'Reactivate',
	'billing.reactivate.error': 'Could not reactivate subscription. Please try again.',
	'billing.cancellation.title': 'Cancellation',
	'billing.cancellation.cancelPlan': 'Cancel plan',
	'billing.cancellation.cancelButton': 'Cancel',
	'billing.cancellation.endingOn':
		'Your Subscription is ending {{date}}. You can reactivate anytime.',
	'billing.cancellation.ending': 'Your Subscription is ending soon. You can reactivate anytime.',
	'billing.credits.buyMore': 'Buy credits',
	'billing.credits.intro':
		'Credits top up your chat quota and are deducted from your balance with each message you send. Purchasing credits is a one-time payment with no recurring charges, and each credit package is valid for one year or until fully used.',
	'billing.credits.packageCredits': '{{credits}} credits',
	'billing.credits.savings': '+{{percent}}% more credits',
	'billing.credits.confirmationTitle': 'Credits added',
	'billing.credits.confirmationBody': '{{credits}} credits have been added to your account.',
	'billing.credits.buyNow': 'Buy now',
	'billing.credits.acceptTermsBefore': 'By clicking "Buy now" you confirm that you agree to our ',
	'billing.credits.estimatedMessages': 'approx. {{min}}–{{max}} questions',
	'billing.credits.estimatedMessagesDisclaimer': 'Ranges assume varying query complexity.',
	'billing.credits.usageTitle': 'How far do credits go?',
	'billing.credits.usageParagraph':
		'Credits are consumed per answer. The exact amount depends on how complex your question is and how much the AI needs to research. Simple direct questions use very few credits. Long conversations and queries that search through many documents use more.',
	'billing.credits.exampleShortLabel': 'Direct question',
	'billing.credits.exampleShortText': 'e.g. "Which party does Lars Klingbeil belong to?"',
	'billing.credits.exampleShortCredits': '5–10 credits',
	'billing.credits.exampleStandardLabel': 'Research with sources',
	'billing.credits.exampleStandardText':
		'e.g. "What has parliament decided on climate protection?"',
	'billing.credits.exampleStandardCredits': '20–50 credits',
	'billing.credits.exampleDeepLabel': 'In-depth analysis',
	'billing.credits.exampleDeepText':
		'e.g. "Give me a detailed comparison of how the parties argued about housing policy in the Bundestag."',
	'billing.credits.exampleDeepCredits': '100–300 credits',
	'billing.credits.planUpsellTitle': 'Monthly quota, personalized briefings and more',
	'billing.credits.planUpsellBody':
		'Our monthly plans give you more than just chat access: a higher usage quota and great features like personalized briefings. If you use parliament.ai regularly, a plan is likely the better fit.',
	'billing.credits.viewPlans': 'View plans',
	'plan.upgrade.earlyAdopterNotice':
		'You are on the Essential plan as a thank you for being an early adopter!',
	'plan.limitReached.title': 'Conversation limit reached',
	'plan.limitReached.description':
		"You've used all {{count}} conversations in your {{plan}} plan. Upgrade to continue chatting.",
	'plan.limitReached.cta': 'Upgrade Plan',
	'briefing.personalized.planGate.title': 'Available on Pro plan',
	'briefing.personalized.planGate.description':
		'Personalized briefings are available for Pro plan subscribers. Upgrade to get daily briefings tailored to your topics.',
	'briefing.personalized.planGate.cta': 'Upgrade Plan',
	'briefing.personalized.chatGate.title': 'Pro plan required',
	'briefing.personalized.chatGate.description':
		'Asking follow-up questions in personalized briefings requires the Pro plan.',
	'briefing.personalized.chatGate.cta': 'Upgrade to Pro',

	// Landing Page
	'landing.hero.brandTag': 'A service by',
	'landing.hero.headline': 'The chatbot platform you can trust',
	'landing.hero.subheadline':
		'Botbakery Platform integrates your knowledge sources with the LLM of your choice. With verifiable citations, GDPR-compliant, and hosted in the EU.',
	'landing.hero.cta': 'Book a demo',

	// Value Propositions
	'landing.benefits.heading': 'Why Choose Botbakery?',
	'landing.benefits.citations.title': 'Verifiable answers through precise citations',
	'landing.benefits.customKnowledge.title': 'Custom knowledge integrated for you',
	'landing.benefits.verifiable.title': 'Verifiable Answers',
	'landing.benefits.verifiable.text':
		'Every answer includes full source citations, so you can verify information and prevent hallucinations.',
	'landing.benefits.private.title': 'Your Private Knowledge',
	'landing.benefits.private.text':
		'Integrate internal documents, wikis, and databases. Your knowledge stays secure and private.',
	'landing.benefits.gdpr.title': 'GDPR Compliant',
	'landing.benefits.gdpr.text':
		'Hosted in the EU with full GDPR compliance. Your data never leaves Europe.',
	'landing.benefits.custom.title': 'Custom Integrations',
	'landing.benefits.custom.text':
		'Deploy via API, web widget, or custom integration. Built for your workflow.',

	// How It Works
	'landing.howItWorks.heading': 'How It Works',
	'landing.howItWorks.step1.title': 'Connect Your Knowledge',
	'landing.howItWorks.step1.description':
		'Import documents, wikis, databases, and any knowledge sources your organization uses.',
	'landing.howItWorks.step2.title': 'Customize Your Assistant',
	'landing.howItWorks.step2.description':
		'Configure RAG parameters, select AI models, and customize for your domain.',
	'landing.howItWorks.step3.title': 'Deploy Anywhere',
	'landing.howItWorks.step3.description':
		'Use via API, embed as a widget, or integrate into your existing tools.',

	// RAG Pipeline (detailed)
	'landing.ragPipeline.heading': 'How Does the Botbakery Platform Work?',
	'landing.ragPipeline.intro':
		'Retrieval-Augmented Generation (RAG) combines targeted document search with modern AI language capabilities. Unlike generic chatbots that answer "from the gut," Botbakery Platform first retrieves relevant facts from your databases—then generates a precise answer based on these sources. The result: reliable, verifiable answers instead of hallucinated "facts."',
	'landing.ragPipeline.step1.title': 'Document Preprocessing',
	'landing.ragPipeline.step1.description':
		'We process your documents with intelligent chunking, create summaries, and extract metadata for optimal searchability',
	'landing.ragPipeline.step2.title': 'Intent Detection',
	'landing.ragPipeline.step2.description':
		'We analyze the user query to understand their intention—this guides the pipeline toward more relevant results and determines whether retrieval is needed or if the model can answer directly',
	'landing.ragPipeline.step3.title': 'Multi-Stage Retrieval',
	'landing.ragPipeline.step3.description':
		'We run retrieval multiple times in successive stages, each time getting closer to the required knowledge—starting broad with document summaries, then narrowing down to specific passages',
	'landing.ragPipeline.step4.title': 'Reranking',
	'landing.ragPipeline.step4.description':
		'We rerank all retrieved results by actual relevance to the specific question, selecting the optimal information for the AI context',
	'landing.ragPipeline.step5.title': 'Response Generation & Citation',
	'landing.ragPipeline.step5.description':
		'We generate a precise answer based on the retrieved sources and automatically insert citations that link every statement back to the original documents for full transparency',

	// Use Cases
	'landing.useCases.heading': 'Built for Your Workflow',
	'landing.useCases.internal.title': 'Internal Knowledge Management',
	'landing.useCases.internal.description':
		'Give your team instant access to company knowledge, policies, and documentation.',
	'landing.useCases.customer.title': 'Customer Success',
	'landing.useCases.customer.description':
		'Automate support with accurate, source-cited answers to customer questions.',
	'landing.useCases.technical.title': 'Technical Documentation',
	'landing.useCases.technical.description':
		'Help developers find API details, code examples, and integration guides.',
	'landing.useCases.research.title': 'Research & Analysis',
	'landing.useCases.research.description':
		'Search through reports, studies, and data with AI-powered insights.',

	// Comparison
	'landing.comparison.heading': 'Why Not Just Use ChatGPT?',
	'landing.comparison.sources': 'Source Citations',
	'landing.comparison.astlai.sources': 'Full citations for every answer',
	'landing.comparison.chatgpt.sources': 'No source references',
	'landing.comparison.knowledge': 'Private Knowledge',
	'landing.comparison.astlai.knowledge': 'Full access to your documents',
	'landing.comparison.chatgpt.knowledge': 'Only public training data',
	'landing.comparison.compliance': 'GDPR Compliance',
	'landing.comparison.astlai.compliance': 'EU-hosted, GDPR compliant',
	'landing.comparison.chatgpt.compliance': 'US-hosted',
	'landing.comparison.customization': 'Customization',
	'landing.comparison.astlai.customization': 'Domain-specific tuning',
	'landing.comparison.chatgpt.customization': 'Generic responses',

	// FAQ
	'landing.faq.heading': 'Frequently Asked Questions',
	'landing.faq.whatIsRag.question': 'What does RAG stand for?',
	'landing.faq.whatIsRag.answer':
		"RAG stands for Retrieval-Augmented Generation. It's an AI technique that combines the power of large language models with your own knowledge base. Instead of relying solely on the AI's training data, RAG systems retrieve relevant information from your documents and use it to generate accurate, source-cited answers.",
	'landing.faq.gdprCompliant.question': 'Is Botbakery Platform GDPR compliant?',
	'landing.faq.gdprCompliant.answer':
		'Yes, absolutely. Botbakery Platform is fully GDPR compliant and hosted in the EU. All data processing occurs within European data centers, your data never leaves the EU, and we follow strict data protection protocols. We provide data processing agreements (DPA) and comprehensive documentation for compliance officers.',
	'landing.faq.privateKnowledge.question': 'Can I integrate my own private knowledge?',
	'landing.faq.privateKnowledge.answer':
		"Yes! That's exactly what Botbakery Platform is built for. You can integrate internal documents, wikis, databases, technical documentation, and any other knowledge sources your organization uses. We handle the entire ETL pipeline, chunking, embedding generation, and deployment. Your knowledge remains private and secure.",
	'landing.faq.whyNotChatGPT.question': 'Why not just use plain ChatGPT?',
	'landing.faq.whyNotChatGPT.answer':
		"While ChatGPT is powerful, it has limitations for enterprise use: No source citations—you can't verify where information comes from. No private knowledge—can't access your internal documents. Hallucinations—may generate plausible but incorrect information. Generic responses—not customized for your domain. Botbakery Platform solves these with full source citations, private knowledge integration, and domain-specific customization—all while being GDPR compliant and EU-hosted.",
	'landing.faq.useCases.question': 'What can I use an Botbakery Platform bot for?',
	'landing.faq.useCases.answer':
		'Common use cases include: Internal knowledge management—give employees instant access to company knowledge. Customer success—automate support with accurate, cited answers. Technical documentation—help developers find API details and code examples. Research & analysis—search through reports, studies, and data. Compliance & legal—query policies, regulations, and legal documents. Training & onboarding—provide new hires with interactive knowledge access.',
	'landing.faq.trustAnswers.question': 'Can I trust the answers?',
	'landing.faq.trustAnswers.answer':
		'While no AI system can guarantee 100% accuracy, Botbakery Platform provides unprecedented transparency through full source citations. Every answer includes references to the exact documents and passages used, allowing you to verify information yourself. This dramatically reduces hallucinations and builds trust. Always review sources for critical decisions.',
	'landing.faq.cost.question': 'What does it cost?',
	'landing.faq.cost.answer':
		'Botbakery Platform is a custom integration service, not an off-the-shelf product. Pricing depends on your specific needs: data volume, update frequency, customization requirements, and deployment method. Contact us for a personalized quote. We focus on delivering quality, domain-specific solutions rather than one-size-fits-all packages.',
	'landing.faq.integrationTime.question': 'How long does integration take?',
	'landing.faq.integrationTime.answer':
		"Integration typically takes 2-6 weeks depending on complexity. Simple document imports can be up and running in days, while complex multi-source integrations with custom workflows may take longer. We'll provide a detailed timeline during the initial consultation.",
	'landing.faq.aiModels.question': 'What AI models do you support?',
	'landing.faq.aiModels.answer':
		'We support all major AI vendors including OpenAI (GPT models), Anthropic (Claude), and Scaleway/Mistral. We help you choose the best model for your use case based on language support, cost, and performance requirements.',

	// CTA
	'landing.cta.heading': 'Ready to Build Your Knowledge Assistant?',
	'landing.cta.description': 'Get started with custom RAG integration today',
	'landing.cta.button': 'Book a Demo'
};

const de: typeof en = {
	'common.save': 'Speichern',
	'common.logout': 'Ausloggen',
	'common.signIn': 'Anmelden',
	'common.rename': 'Umbenennen',
	'common.delete': 'Löschen',
	'common.upload': 'Hochladen',
	'common.replace': 'Ersetzen',
	'common.sources': 'Quellen',
	'common.hello': 'Hallo',
	'common.by': 'von',
	'common.and': 'und',
	'common.privacy': 'Datenschutz',
	'common.imprint': 'Impressum',
	'common.terms': 'Nutzungsbedingungen',
	'common.copy': 'Kopieren',
	'common.copied': 'Kopiert!',
	'common.close': 'Schließen',
	'common.unread': 'Ungelesen',
	'common.notSelected': 'Nicht ausgewählt',
	'common.confirm': 'Bestätigen',
	'common.yes': 'Ja',
	'common.no': 'Nein',
	'common.adminOnly': 'Noch nicht für alle Nutzer freigegeben',

	'releaseNotes.title': 'Release Notes',
	'releaseNotes.current': 'Aktuelle Version',
	'releaseNotes.previous': 'Frühere Versionen',

	'error.network':
		'Keine Verbindung mit dem Internet. Bitte überprüfe deine Internetverbindung und versuche es erneut.',
	'error.overloaded':
		'Der Service ist vorübergehend überlastet. Bitte versuche es in einem Moment erneut.',
	'error.notFound': 'Nicht gefunden',
	'error.unknown': 'Unbekannter Fehler',
	'error.creditLimitExceededDay':
		'Das heutige Fair-Use-Limit ist erreicht. Kaufe zusätzliche Credits, um weiterzuchatten.',
	'error.usageLimitExceeded':
		'Für dieses Gerät wurde das Nutzungslimit für diese Ausstellung erreicht. Bitte versuche es über ein anderes Netzwerk erneut oder wende dich an das Team vor Ort.',

	'nav.data': 'Wissensspeicher',
	'nav.briefing': 'Alle Briefings',
	'nav.history': 'Alle Chats',
	'nav.instanceAdminSettings': 'Admin-Einstellungen',
	'nav.users': 'Nutzerverwaltung',
	'nav.organizations': 'Organisationen',
	'nav.recentChats': 'Letzte Chats',
	'nav.newestBriefings': 'Aktuelle Briefings',
	'nav.antonio.chatLink': 'Chat',
	'nav.antonio.galleryLink': 'Galerie',
	'nav.antonio.imagesLink': 'Bilder',
	'nav.antonio.screen': 'Screen',
	'nav.antonio.screenFeed': 'Feed',
	'nav.antonio.publicChatLink': 'Öffentlicher Chat-Link',

	'users.title': 'Nutzerverwaltung',
	'users.empty': 'Keine Nutzer gefunden',
	'users.role': 'Rolle',
	'users.role.user': 'User',
	'users.role.admin': 'Admin',
	'users.conversations': 'Chats',
	'users.messages': 'Nachrichten',
	'users.tokens': 'Tokens',
	'users.credits': 'Credits (Lifetime)',
	'users.periodCredits': 'Verbrauchte Credits',
	'users.softLimit': 'Weiches Limit',
	'users.quotaUsed': '% Kontingent',
	'users.bonusCredits': 'Extra Credits',
	'users.lifetimeUsage': 'Gesamtnutzung',
	'users.creditGrants': 'Credit-Gutschriften',
	'users.grantBalance': 'Guthaben',
	'users.grantAmount': 'Betrag',
	'users.grantNote': 'Notiz (optional)',
	'users.addGrant': 'Gutschrift hinzufügen',
	'users.noGrants': 'Noch keine Gutschriften.',
	'users.noConversations': 'Noch keine Chats.',
	'users.created': 'Erstellt',
	'users.lastActivity': 'Letzte Aktivität',
	'users.never': 'Nie',
	'users.plan': 'Plan',
	'users.organization': 'Organisation',
	'users.organization.all': 'Alle Organisationen',
	'users.organization.none': 'Keine Organisation',
	'users.organization.joinHint':
		'Beim Beitritt bekommt die Person den Plan der Organisation und die Abrechnung per Rechnung. Beim Austritt bleibt beides.',
	'users.delete': 'Nutzer löschen',
	'users.delete.confirm': 'Nutzer wirklich löschen?',
	'users.delete.warning':
		'Das Nutzerkonto und alle zugehörigen Daten werden unwiderruflich gelöscht.',
	'users.itsYou': 'das bist du',
	'users.search': 'Nutzer suchen…',
	'users.status': 'Status',
	'users.verified': 'Verifiziert',
	'users.notVerified': 'Nicht verifiziert',
	'users.customBilled': 'Individualabrechnung',
	'users.softDeleted': 'Soft Deleted',
	'users.authProviders': 'Auth-Anbieter',
	'users.activeBriefings': 'Aktive Briefings',
	'users.exemptCredits': 'Nicht getrackte Credits (Briefings)',
	'users.subscribed': 'Abonniert',
	'users.stripeCustomer': 'Stripe-Kunde',
	'users.stripeSubscription': 'Stripe-Abonnement',
	'users.stripe': 'Stripe',
	'users.id': 'ID',
	'users.internal': 'Interner Nutzer',
	'users.internal.description': 'Von Analysen und Nutzungsberichten ausgeschlossen.',
	'users.nav.general': 'Allgemein',
	'users.nav.usage': 'Nutzung und Credits',
	'users.nav.chats': 'Chats',
	'users.nav.debug': 'Debug',
	'users.debug.viewState': 'View State',

	'organizations.title': 'Organisationen',
	'organizations.empty': 'Noch keine Organisationen',
	'organizations.create': 'Neue Organisation',
	'organizations.create.submit': 'Erstellen',
	'organizations.name': 'Name',
	'organizations.plan.hint':
		'Mitglieder bekommen diesen Plan beim Beitritt. Bestehende Mitglieder behalten ihren.',
	'organizations.emailDomains': 'E-Mail-Domains',
	'organizations.emailDomains.hint':
		'Neue Nutzer mit einer Adresse an einer dieser Domains treten bei der Registrierung automatisch bei. Bestehende Nutzer nicht: Füge sie auf ihrer Nutzerseite hinzu.',
	'organizations.emailDomains.input': 'Domain, z. B. example.com',
	'organizations.emailDomains.add': 'Hinzufügen',
	'organizations.emailDomains.empty': 'Keine Domains',
	'organizations.seats': 'Plätze',
	'organizations.seatLimit': 'Platzlimit',
	'organizations.seatLimit.hint':
		'Mit dem Kunden vereinbarte Plätze. Wird nur angezeigt, nie erzwungen. 0 für keins.',
	'organizations.logo': 'Logo',
	'organizations.nav.general': 'Allgemein',
	'organizations.nav.members': 'Mitglieder',
	'organizations.members.empty': 'Noch keine Mitglieder. Füge Nutzer auf ihrer Nutzerseite hinzu.',
	'organizations.members.deactivated': 'Deaktiviert',

	'briefing.title': 'Briefings',
	'briefing.global': 'Allgemeines Briefing',
	'briefing.global.askFollowUp': 'Folgefragen stellen',
	'briefing.heading': 'Tägliches Parlamentsbriefing vom {{date}}',
	'briefing.emptyState': 'Kein Briefing für heute verfügbar. Versuch es morgen nochmal!',
	'briefing.loading': 'Lade heutiges Briefing...',
	'briefing.errorLoading': 'Fehler beim Laden des Briefings',
	'briefing.coveragePeriod': 'Abdeckungszeitraum',
	'briefing.generatedOn': 'Generiert am',
	'briefing.personalized.title': 'Personalisiertes Briefing',
	'briefing.personalized.coverageLabel': 'Zeitraum',
	'briefing.personalized.openBriefing': 'Briefing öffnen & Fragen stellen',
	'briefing.personalized.nullReport': 'Nullmeldung',
	'briefing.personalized.resultsFound': 'Inhalte gefunden',
	'briefing.personalized.activeNoResults':
		'Dein Abonnement ist aktiv — dein erstes Briefing erscheint morgen.',
	'briefing.personalized.subInactive':
		'Dein Abonnement ist pausiert. Aktiviere es, um täglich Briefings zu erhalten.',
	'briefing.personalized.emptyState':
		'Richte dein personalisiertes Briefing ein, um täglich Updates zu den Themen zu erhalten, die dich interessieren.',
	'briefing.subscription.title': 'Personalisierte Briefings',
	'briefing.subscription.setup': 'Personalisiertes Briefing einrichten',
	'briefing.subscription.description':
		'Beschreibe deine Rolle und Themen in normaler Sprache – je mehr Kontext du gibst, desto besser wird das Briefing. Stichwörter eignen sich für konkrete Begriffe, die wortwörtlich vorkommen sollen, z.B. Namen, Gesetzesnamen oder Organisationen.',
	'briefing.subscription.name': 'Name',
	'briefing.subscription.namePlaceholder': 'z.B. Klima- & Energiepolitikbriefing',
	'briefing.subscription.topicPrompt': 'Briefing Prompt',
	'briefing.subscription.topicPromptPlaceholder':
		'z.B. "Ich bin verantwortlich für die Kommunikation in einer NGO, meine Themengebiete sind Klimaschutz, Artenvielfalt und Tierschutz."',
	'briefing.subscription.keywords': 'Optional: Wortgenaue Stichwörter (kommagetrennt)',
	'briefing.subscription.keywordsPlaceholder':
		'z.B. Gebäudeenergiegesetz, Grundrente, Bundesnetzagentur',
	'briefing.subscription.proFeature': 'Pro-Feature',
	'briefing.subscription.keywordsProOnly': 'Stichwort-Filterung ist im Pro-Plan verfügbar.',
	'briefing.subscription.keywordsProOnlyLink': 'Auf Pro upgraden',
	'briefing.subscription.deliveryEmail': 'Zustellungs-E-Mail-Adresse',
	'briefing.subscription.deliveryEmailPlaceholder': 'z.B. team@beispiel.de',
	'briefing.subscription.deliveryEmailProOnly':
		'Individuelle Zustelladresse ist im Pro-Plan verfügbar.',
	'briefing.subscription.deliveryEmailProOnlyLink': 'Auf Pro upgraden',
	'briefing.subscription.emailNotifications': 'E-Mail Benachrichtigungen',
	'briefing.subscription.sendNullReport':
		'E-Mail auch senden, wenn nichts gefunden wurde (Nullmeldung)',
	'briefing.subscription.isActive': 'Aktiv',
	'briefing.subscription.isPaused': 'Pausiert',
	'briefing.subscription.personalized': 'Personalisiertes Briefing',
	'briefing.subscription.emailDelivery': 'E-Mails werden gesendet an {{email}}',
	'briefing.subscription.save': 'Speichern',
	'briefing.subscription.saved': 'Gespeichert',
	'briefing.subscription.pause': 'Pausieren',
	'briefing.subscription.resume': 'Fortsetzen',
	'briefing.subscription.delete': 'Briefing-Abo löschen',
	'briefing.subscription.edit': 'Bearbeiten',
	'briefing.subscription.generate.title': 'Jetzt generieren',
	'briefing.subscription.generate.from': 'Von',
	'briefing.subscription.generate.to': 'Bis',
	'briefing.subscription.generate.button': 'Generieren',
	'briefing.subscription.generate.success': 'Generiert — Briefing öffnen',
	'briefing.global.info':
		'Das allgemeine tägliche Briefing ist eine täglich (Di-Sa) generierte Zusammenfassung aller wichtigen parlamentarischen Debatten und Entscheidungen des Vortages.',
	'briefing.personalized.info':
		'Beobachte parlamentarische Aktivitäten zu deinen Themen täglich. Gefiltert auf deine Stichwörter – mit Nullmeldung, wenn nichts Relevantes gefunden wurde. Wird jeden Morgen generiert; optional per E-Mail zugestellt.',
	'briefing.newBriefing': 'Neues Briefing',
	'briefing.subscription.add': 'Briefing-Abo hinzufügen',
	'briefing.subscription.globalSubtitle': 'Tägliches Briefing für alle NutzerInnen',
	'briefing.subscription.freeGate':
		'Personalisierte Briefings erfordern mindestens den Essential-Plan.',
	'briefing.subscription.essentialHint':
		'Der Pro-Plan umfasst bis zu 5 personalisierte Briefing-Abos und mehr Einstellungsmöglichkeiten.',
	'briefing.subscription.atLimit': 'Du hast das Abo-Limit deines Plans erreicht.',
	'briefing.global.title': 'Allgemeines Tages-Briefing',

	'auth.signIn.title': 'Login',
	'auth.signIn.titleWithInstance': '{{instance}} Login',
	'auth.signIn.subtitle': 'Melde dich bei deinem Botbakery-Konto an.',
	'auth.signIn.signinSubtitle': 'Gib dein Passwort ein, um auf dein Botbakery-Konto zuzugreifen.',
	'auth.signIn.email': 'E-Mail',
	'auth.signIn.password': 'Passwort',
	'auth.signIn.continueWithEmail': 'Weiter',
	'auth.signIn.or': 'oder',
	'auth.signIn.signInWithGoogle': 'Mit Google anmelden',
	'auth.signIn.signInWithMicrosoft': 'Mit Microsoft anmelden',
	'auth.signIn.forgotPassword': 'Passwort vergessen?',
	'auth.signIn.createAccount': 'Account erstellen',
	'auth.signIn.welcome': 'Willkommen!',
	'auth.signIn.welcomeBack': 'Willkommen zurück!',
	'auth.signIn.invalidEmail': 'Bitte gib eine gültige E-Mail-Adresse ein',
	'auth.signIn.fillAllFields': 'Bitte fülle alle Felder aus',

	'auth.activation.title': 'E-Mail-Adresse bestätigen',
	'auth.activation.message':
		'Wir haben eine E-Mail mit einem Aktivierungslink an {{email}} geschickt. Klicke darauf, um deinen Account zu aktivieren, und melde dich dann an.',
	'auth.activation.resend': 'Erneut senden',
	'auth.activation.goToSignIn': 'Zur Anmeldung',
	'auth.activation.resent': 'Aktivierungs-E-Mail gesendet!',

	'auth.reset.title': 'Passwort zurücksetzen',
	'auth.reset.message':
		'Gib die E-Mail adresse von deinem Acounnt hier ein und wir schicken dir einen reset-Link',
	'auth.reset.success':
		'Passwort-Reset für {email} angefordert. Falls diese E-Mail mit einem {{instanceName}} Account verknüpft ist, hast du eine E-Mail mit einem Reset-Link erhalten.',
	'auth.reset.backToLogin': 'Zurück zum Login',
	'auth.reset.email': 'E-Mail',
	'auth.reset.submit': 'Reset-Link senden',
	'auth.reset.error': 'Fehler beim Zurücksetzen des Passworts',
	'auth.confirmReset.title': 'Neues Passwort',
	'auth.confirmReset.success':
		'Passwort wurde erfolgreich gesetzt! Du kannst dich nun mit deinem neuen Passwort einloggen.',
	'auth.confirmReset.message': 'Bitte setze ein neues Passwort',
	'auth.confirmReset.password': 'Passwort',
	'auth.confirmReset.passwordConfirm': 'Passwort bestätigen',
	'auth.confirmReset.submit': 'Speichern',
	'auth.confirmReset.toLogin': 'Zum Login',

	'auth.signup.title': 'Account erstellen',
	'auth.signup.subtitle': 'Nur noch ein paar Angaben, um dein Botbakery-Konto einzurichten.',
	'auth.signup.firstName': 'Vorname',
	'auth.signup.lastName': 'Nachname',
	'auth.signup.password': 'Passwort',
	'auth.signup.passwordConfirm': 'Passwort bestätigen',
	'auth.signup.passwordsNotEqual': 'Passwörter stimmen nicht überein',
	'auth.signup.submit': 'Account erstellen',
	'auth.signup.notApproved':
		'Leider ist dein Account noch nicht freigeschaten. Versuch es später nochmal.',
	'auth.signup.success': 'Dein Account wurde erfolgreich angelegt! Du kannst dich nun einloggen.',
	'auth.signup.toLogin': 'Zum Login',
	'auth.signup.needInfo': 'Wir brauchen noch ein paar Infos von dir',
	'auth.signup.acceptTerms': 'Ich akzeptiere die {{terms}} und {{privacy}}',
	'auth.signup.termsRequired': 'Du musst die Nutzungsbedingungen akzeptieren',
	'auth.signup.fillAllFields': 'Bitte fülle alle Pflichtfelder aus',

	'auth.unsubscribe.title': 'Austragen',
	'auth.unsubscribe.success': 'Deine E-Mail wurde erfolgreich aus unserem System gelöscht.',
	'auth.unsubscribe.confirmMessage': 'Schade, dass du dich aus der Warteliste austragen möchtest.',
	'auth.unsubscribe.confirmQuestion': 'Bist du dir sicher?',
	'auth.unsubscribe.submit': 'Ja, löscht meine E-Mail Adresse',
	'auth.verify.successTitle': 'E-Mail bestätigt!',
	'auth.verify.successMessage':
		'Deine E-Mail-Adresse wurde verifiziert. Du kannst dich jetzt anmelden.',
	'auth.verify.toLogin': 'Anmelden',
	'auth.verify.errorTitle': 'Fehler',
	'auth.verify.errorMessage': 'Es gab leider einen Fehler bei der Verifizierung :(',
	'auth.oauth.title': 'Zugriff erlauben?',
	'auth.oauth.heading': '{{client}} möchte auf dein Konto zugreifen',
	'auth.oauth.permissions': 'Wenn du zustimmst, kann die App:',
	'auth.oauth.permissionAccount': 'Deine E-Mail-Adresse und Rolle sehen',
	'auth.oauth.permissionActAs': '{{instance}} in deinem Namen nutzen, mit deinen Berechtigungen',
	'auth.oauth.redirect': 'Danach wirst du zu {{client}} zurückgeleitet.',
	'auth.oauth.redirectLocal': 'Danach wirst du zur App zurückgeleitet.',
	'auth.oauth.clientClaude': 'Claude',
	'auth.oauth.clientChatgpt': 'ChatGPT',
	'auth.oauth.clientLangdock': 'Langdock',
	'auth.oauth.clientClaudeCode': 'Claude Code',
	'auth.oauth.clientCodex': 'Codex',
	'auth.oauth.clientVscode': 'Visual Studio Code',
	'auth.oauth.clientLocal': 'Eine App auf diesem Computer',
	'auth.oauth.allow': 'Erlauben',
	'auth.oauth.deny': 'Ablehnen',
	'auth.oauth.invalid':
		'Diese Autorisierungsanfrage ist ungültig. Starte die Verbindung erneut aus deiner App.',
	'auth.oauth.forbidden': 'Du hast keinen Zugriff auf diese App.',

	'chat.welcome': 'wie kann ich dir heute weiter helfen?',
	'chat.new': 'Neuer Chat',
	'chat.info': 'Chat Info',
	'chat.rename': 'Chat Umbenennen',
	'chat.delete': 'Chat Löschen',
	'chat.delete.question': 'Möchtest du diesen Chat wirklich löschen?',
	'chat.delete.confirm': 'Ja, löschen',
	'chat.delete.cancel': 'Nein, nicht löschen',
	'chat.share': 'Teilen',
	'chat.share.intro': 'Lege fest, wer diese Unterhaltung sehen kann.',
	'chat.share.description': 'Jeder mit dem Link kann diese Unterhaltung lesen.',
	'chat.share.enable': 'Teilen aktivieren',
	'chat.share.hint': 'Du kannst das Teilen jederzeit deaktivieren, um den Zugriff zu entziehen.',
	'chat.share.private': 'Privat',
	'chat.share.private.description': 'Nur du kannst auf diesen Chat zugreifen.',
	'chat.share.public': 'Öffentlich',
	'chat.share.public.description': 'Jeder mit dem Link kann diesen Chat sehen.',
	'chat.disclaimer': '{{instanceName}} kann Fehler machen',
	'chat.disclaimerCheckSources': 'Überprüfe alle Quellen immer sorgfältig',
	'chat.developedBy': 'Entwickelt von',
	'chat.adminView': 'Du siehst die Unterhaltung eines anderen Nutzers.',
	'chat.placeholder': 'Frag mich was...',
	'chat.antonioPlaceholder': 'Deine Antwort...',
	'chat.debugInfo': 'Debug Info',
	'chat.retry': 'Neu generieren',
	'chat.regenerate': 'Regenerieren',
	'chat.incomplete': 'Antwort gestoppt',
	'chat.incompleteTooltip':
		'Du hast die Generierung der Antwort unterbrochen bevor sie vollständig war',
	'chat.stopResponse': 'Antwort stoppen',
	'chat.attach': 'Dateien anhängen',
	'chat.attachment.remove': 'Anhang entfernen',
	'chat.attachment.dropHere': 'Dateien hier ablegen',
	'chat.attachment.pages': '{{count}} Seiten',
	'chat.attachment.error.fileTooLarge': 'Größer als {{limit}} MB',
	'chat.attachment.error.tooManyPages': 'Mehr als {{limit}} Seiten',
	'chat.attachment.error.tooLong': 'Zu viel Text für eine Nachricht',
	'chat.attachment.error.unsupportedType': 'Dateityp nicht unterstützt',
	'chat.attachment.error.unreadable': 'Die Datei konnte nicht gelesen werden',
	'chat.attachment.error.failed': 'Hochladen fehlgeschlagen',
	'chat.attachment.error.tooManyFiles': 'Höchstens {{limit}} Dateien pro Nachricht',
	'chat.attachment.error.tooLongTogether':
		'Zusammen enthalten diese Dateien zu viel Text für eine Nachricht. Entferne einige davon.',
	'chat.secondarySources': 'Sekundärquellen',
	'chat.secondarySources.none': 'Keine',
	'chat.sources.webSearch': 'Websuche',
	'chat.sources.webSearch.description': 'Im Web nach zusätzlichen Informationen suchen',
	'chat.sources.lobbyregister': 'Lobbyregister',
	'chat.sources.lobbyregister.description':
		'Interessenvertreter und ihre Auftraggeber aus dem Lobbyregister',
	'chat.sources.fragdenstaat': 'FragDenStaat',
	'chat.sources.fragdenstaat.description':
		'IFG-Anfragen (Informationsfreiheit) an deutsche Behörden',
	'chat.sources.abgeordnetenwatch': 'Abgeordnetenwatch',
	'chat.sources.abgeordnetenwatch.description':
		'Profile von Abgeordneten und deren Nebentätigkeiten',
	'chat.lastMessage': 'Letzte Nachricht',
	'chat.emptyHistory': 'Keine Chats vorhanden',
	'chat.unnamed': 'Unbenannter Chat',
	'chat.apiKeyOrigin': 'Über die API erstellt',
	'chat.untitled': 'Unbenannter Chat',
	'chat.search.placeholder': 'Chats durchsuchen…',
	'chat.search.noResults': 'Keine Chats gefunden.',
	'chat.createdViaApiKey': 'Über API-Key "{{name}}" erstellt',
	'chat.fetching.thinking': 'Denke nach...',
	'chat.fetching.analyticalQuery': 'Durchsuche Datenbank...',
	'chat.fetching.searchSources': 'Suche Quellen...',
	'chat.fetching.sourcesFound': 'Quellen gefunden...',
	'chat.reasoning': 'Gedanken',
	'chat.toolCalls': 'Recherche',
	'chat.tab.toolCalls': 'Aktionen',
	'chat.tab.reasoning': 'Gedanken',
	'chat.tool.knowledgeBase': 'Wissensbasis',
	'chat.tool.vectorSearch': 'Vektorsuche',
	'chat.tool.keywordSearch': 'Schlüsselwortsuche',
	'chat.tool.document': 'Dokument',
	'chat.tool.context': 'Kontext',
	'chat.tool.webSearch': 'Websuche',
	'chat.tool.website': 'Website',
	'chat.tool.parliament': 'Parlament',
	'chat.tool.lobbyregister': 'Lobbyregister',
	'chat.tool.lobbyregisterEntry': 'Lobbyregister-Eintrag',
	'chat.tool.politicians': 'Abgeordnete',
	'chat.tool.votes': 'Abstimmungen',
	'chat.tool.kleineAnfragen': 'Kleine Anfragen',
	'chat.tool.fragdenstaat': 'FragDenStaat',
	'chat.tool.briefingStatus': 'Briefing wird abgeschlossen',
	'chat.tool.generateImage': 'Bild generieren',
	'chat.tool.result': 'Ergebnis',
	'chat.tool.results': 'Ergebnisse',
	'chat.copyPlainText': 'Als Text kopieren',
	'chat.copyMarkdown': 'Als Markdown kopieren',

	'data.emptyState': 'Keine Daten verfügbar',
	'data.importedOn': 'Importiert am',
	'data.document': 'Dokument',
	'data.documents': 'Dokumente',
	'data.speech': 'Rede',
	'data.speeches': 'Reden',
	'data.openSource': 'Quelle öffnen',
	'data.loadError': 'Fehler beim Laden der Daten',
	'data.latestUpdate': 'Letztes Update',
	'data.documentsInKnowledgeStore': 'Dokumente im Wissensspeicher*',
	'data.documentTypesExplanation':
		'* Dokumente umfassen verschiedene Inhaltstypen wie Artikel, Gesetze, Reden und andere Dokumente.',
	'data.description':
		'Wir aktualisieren den Wissensspeicher regelmäßig mit neuen Daten. Alle hier aufgeführten Informationen stehen dem Bot zur Verfügung und können in Konversationen durchsucht und referenziert werden. Informationen, die nicht auf dieser Seite aufgeführt sind, sind für den Bot nicht zugänglich.',
	'data.topicsInDebate': 'Themen in dieser Debatte:',
	'data.tabs.resources': 'Ressourcen',
	'data.metadata': 'Metadaten',
	'data.metadata.document': 'Dokument-Metadaten',
	'data.metadata.resource': 'Ressourcen-Metadaten',

	'settings.instance.nav.importJobs': 'Import Jobs',
	'settings.instance.nav.pdfExtractor': 'PDF Extraktor',
	'settings.instance.nav.briefings': 'Briefings',

	'settings.instance.briefings.title': 'Briefing-Einstellungen',
	'settings.instance.briefings.dailyBriefing': 'Tägliches Briefing aktivieren',
	'settings.instance.briefings.dailyBriefing.description':
		'Erstellt täglich ein globales Briefing für alle Nutzer dieser Instanz.',
	'settings.instance.briefings.globalPrompt': 'Thema Tagesbriefing',
	'settings.instance.briefings.globalPrompt.description':
		'Beschreibe, was das globale Tagesbriefing abdecken soll. Wenn leer, wird ein allgemeiner parlamentarischer Überblick erstellt.',

	'data.noDocuments':
		'Keine Dokumente in dieser Ressource. Das bedeutet in aller Regel, dass der Import noch nicht abgeschlossen ist, oder noch keine Dokumente zu diesem Thema vorliegen. Versuche es später nochmal.',
	'data.search': 'Ressourcen suchen',
	'data.col.name': 'Name',
	'data.col.type': 'Typ',
	'data.col.date': 'Datum',
	'data.col.imported': 'Importiert',
	'data.col.documents': 'Dokumente',
	'data.clearTypeFilter': 'Filter entfernen',

	'resourceType.debate': 'Debatte',
	'resourceType.press_message': 'Parlamentsnachrichten',
	'resourceType.person': 'Person',
	'resourceType.eu_cod': 'EU Mitentscheidung',
	'resourceType.cla': 'CLA',
	'resourceType.kleine_anfrage': 'Kleine Anfrage',

	'docType.speech': 'Debatte im Bundestag',
	'docType.politician_bio': 'Person',
	'docType.eu_com_proposal': 'Commission Proposal',
	'docType.eu_ep_amendments_adopted': 'Adopted Amendments',
	'docType.eu_ep_cmt_opinion': 'Committee Opinion',
	'docType.eu_egp_briefing': 'EGP Internal Briefing',
	'docType.press_message': 'Parlamentsnachrichten "heute im bundestag"',
	'docType.kleine_anfrage': 'Kleine Anfrage',
	'docType.antwort_kleine_anfrage': 'Antwort der Bundesregierung',
	'docType.podcast_transscript': 'Podcast Transkript',
	'docType.generic_document': 'Dokument',

	'secondarySourceType.person': 'Person',
	'secondarySourceType.company': 'Organisation',
	'secondarySourceType.ifg_request': 'IFG-Anfrage',
	'secondarySourceType.poll': 'Abstimmung',
	'secondarySource.fetchedAt': 'Abgerufen am {{date}}',

	'assets.header': 'Assets',
	'assets.placeholder': 'Generierte Bilder und Dateien werden hier angezeigt',
	'assets.untitled': 'Unbenanntes Element',
	'assets.download': 'Herunterladen',
	'assets.kind.image': 'Bild',
	'assets.kind.file': 'Datei',

	'screen.empty': 'Noch keine Bilder vorhanden',
	'screen.footer': 'Alle Bilder wurden von Besucher*innen der Ausstellung generiert',
	'screen.scanToShare': 'Scannen zum Ansehen und Teilen',
	'screen.unknownVisitor': 'Unbekannt',
	'screen.noDescription': 'Beschreibung nicht verfügbar',

	'images.title': 'Bilder',
	'images.empty': 'Noch keine Bilder',
	'images.search': 'Bilder durchsuchen',
	'images.visibility': 'Sichtbarkeit',
	'images.visibilityOption.public': 'Öffentlich',
	'images.visibilityOption.private': 'Privat',
	'images.selectAll': 'Alle auswählen',
	'images.selectedCount': '{{count}} ausgewählt',
	'images.clearSelection': 'Auswahl aufheben',
	'images.changeVisibility': 'Sichtbarkeit ändern',
	'images.bulkVisibility.public': '{{count}} Bilder werden auf öffentlich gesetzt.',
	'images.bulkVisibility.private': '{{count}} Bilder werden auf privat gesetzt.',

	'sources.header': 'Quelldokumente',
	'sources.headerDetail': 'Quelldokument',
	'sources.documents': 'Dokumente',
	'sources.documentLink': 'Dokumentenlink',
	'sources.content': 'Text',
	'sources.pdfPreview': 'PDF',
	'sources.metadata': 'Info',
	'sources.summary': 'Zusammenfassung',
	'sources.details': 'Details',
	'sources.originalText': 'Originaltext',
	'sources.placeholder':
		'Quellen und Kontextinformationen werden hier auftauchen, sobald du mit der Konversation beginnst',
	'sources.primarySources': 'Wissensbasis',
	'sources.secondarySources': 'Sekundärquellen',
	'sources.openSource': 'Quelle öffnen',
	'sources.person.party': 'Partei',
	'sources.person.born': 'Geboren',
	'sources.person.occupation': 'Beruf',
	'sources.person.education': 'Ausbildung',
	'sources.person.residence': 'Wohnort',
	'sources.person.fraction': 'Fraktion',
	'sources.person.parliament': 'Parlament',
	'sources.person.constituency': 'Wahlkreis',
	'sources.person.mandateWon': 'Mandat',
	'sources.person.mandate.constituency': 'Direktmandat',
	'sources.person.mandate.list': 'Landesliste',
	'sources.person.mandate.movedUp': 'Nachgerückt',
	'sources.person.sidejobs': 'Nebentätigkeiten',
	'sources.person.committees': 'Ausschuss-Mitgliedschaften',
	'sources.person.committeeRole.member': 'Mitglied',
	'sources.person.committeeRole.alternateMember': 'Stellv. Mitglied',
	'sources.person.committeeRole.chairperson': 'Vorsitz',
	'sources.person.committeeRole.viceChairperson': 'Stellv. Vorsitz',
	'sources.person.incomeLevel': 'Einkommensstufe {{level}}',
	'sources.person.questionsReceived': 'Fragen erhalten',
	'sources.person.questionsAnswered': 'Fragen beantwortet',
	'sources.person.registerNumber': 'Registernummer',
	'sources.person.activityType': 'Tätigkeit',
	'sources.person.fieldsOfInterest': 'Interessengebiete',
	'sources.person.financialExpenses': 'Lobbyausgaben',
	'sources.company.registerNumber': 'Registernummer',
	'sources.company.legalForm': 'Rechtsform',
	'sources.company.active': 'Aktiv',
	'sources.company.activityType': 'Tätigkeit',
	'sources.company.activityDescription': 'Beschreibung',
	'sources.company.fieldsOfInterest': 'Interessengebiete',
	'sources.company.financialExpenses': 'Lobbyausgaben',
	'sources.company.employeeFte': 'Lobbymitarbeiter (VZÄ)',
	'sources.company.legalRepresentatives': 'Gesetzliche Vertreter',
	'sources.company.entrustedPersons': 'Betraute Personen',
	'sources.company.members': 'Mitglieder',
	'sources.company.memberships': 'Mitgliedschaften',
	'sources.company.fundingSources': 'Finanzierungsquellen',
	'sources.company.publicAllowances': 'Öffentliche Zuwendungen',
	'sources.company.legislativeProjects': 'Gesetzgebungsvorhaben',
	'sources.company.clientOrganizations': 'Auftraggeber',
	'sources.company.codexViolations': 'Kodex-Verstöße',
	'sources.foi.status': 'Status',
	'sources.foi.resolution': 'Ergebnis',
	'sources.foi.refusalReason': 'Ablehnungsgrund',
	'sources.foi.authority': 'Behörde',
	'sources.foi.jurisdiction': 'Zuständigkeit',
	'sources.foi.filed': 'Eingereicht',
	'sources.foi.dueDate': 'Frist',
	'sources.foi.lastMessage': 'Letzte Nachricht',
	'sources.foi.costs': 'Kosten',
	'sources.poll.date': 'Datum',
	'sources.poll.passed': 'Angenommen',
	'sources.poll.rejected': 'Abgelehnt',
	'sources.poll.parliament': 'Parlament',
	'sources.poll.topics': 'Themen',
	'sources.description': 'Beschreibung',
	'sources.citedPassages': 'Zitierte Passagen',
	'sources.copyrightNotice':
		'Es werden nur zitierte Ausschnitte angezeigt. Besuche den Quellenlink, um den vollständigen Inhalt zu lesen.',
	'sources.summaryNotAvailable': 'Noch keine Zusammenfassung verfügbar.',

	'settings.locale': 'Sprache',
	'settings.locale.de': 'Deutsch',
	'settings.locale.en': 'Englisch',

	'settings.theme': 'Design',
	'settings.theme.light': 'Hell',
	'settings.theme.dark': 'Dunkel',
	'settings.theme.system': 'Systemstandard',

	'settings.title': 'Einstellungen',
	'settings.user.name': 'Name',
	'settings.user.firstName': 'Vorname',
	'settings.user.lastName': 'Nachname',
	'settings.user.bio': 'Was der Agent über dich wissen sollte',
	'settings.user.bioPlaceholder':
		'z. B. "Ich bin Politikberaterin mit Schwerpunkt Wohnrecht. Besonders relevant für mich sind Mietrecht, sozialer Wohnungsbau und Stadtentwicklung."',
	'settings.user.email': 'E-Mail',
	'settings.user.username': 'Username',
	'settings.user.defaultModel': 'Standard Model',
	'settings.billing.title': 'Abrechnung',
	'settings.billing.currentPlan': 'Aktueller Plan',
	'settings.deleteAccount': 'Konto löschen',
	'settings.deleteAccount.title': 'Konto löschen',
	'settings.deleteAccount.warning':
		'Diese Aktion plant die Löschung deines Kontos. Alle deine Daten, einschließlich Unterhaltungen, Einstellungen und persönlicher Informationen, werden dauerhaft entfernt.',
	'settings.deleteAccount.gracePeriod':
		'Du hast 30 Tage Zeit, deine Meinung zu ändern. In diesem Zeitraum kannst du den Support kontaktieren, um dein Konto wiederherzustellen. Nach 30 Tagen werden alle Daten dauerhaft gelöscht.',
	'settings.deleteAccount.confirm': 'Ja, mein Konto löschen',
	'settings.deleteAccount.cancel': 'Abbrechen',
	'settings.deleteAccount.activeSubscription':
		'Du hast ein aktives Abonnement. Bitte kündige dein Abonnement, bevor du dein Konto löschst.',

	'settings.instance.title': 'Instanz-Einstellungen',
	'settings.instance.name': 'Instanz-Name',
	'settings.instance.primer': 'Primer',
	'settings.instance.primer.description.standard':
		'Im Hintergrund wird dies mit festen Anweisungen kombiniert: Rollenrahmen, aktuelles Datum, Antwortstil, Hinweise zu den Fähigkeiten (was der Assistent kann/nicht kann) sowie, falls aktiviert, Tool- und Zitierregeln. Halte diesen Primer auf den Themenbereich und Ton dieser Instanz fokussiert.',
	'settings.instance.primer.description.antonio':
		'Im Hintergrund wird dies mit festen Anweisungen kombiniert: Rollenrahmen, aktuelles Datum und Antwortrichtlinien, sowie der generische Antonio-Mode-Ablauf: Fragen einzeln stellen, vor der Generierung bestätigen lassen, das Bild generieren, Name/Email zum Speichern abfragen und sich verabschieden. Beschreibe hier nur, worum es in diesem Projekt geht und welche Fragen gestellt werden sollen. Der Ablauf drumherum wird bereits automatisch ergänzt.',
	'settings.instance.logo': 'Logo',
	'settings.instance.language': 'Sprache',
	'settings.instance.onboardingContent':
		'Login-Popup (Markdown, wird beim ersten Einloggen angezeigt)',
	'settings.instance.responseStyle': 'Antwort-Stil',
	'settings.instance.knowledgeBase': 'Wissensbasis-Kontext',
	'settings.instance.featureFlags': 'Feature Flags',
	'settings.instance.billing.enabled': 'Billing aktivieren',
	'settings.instance.billing.enabled.description':
		'Aktiviert Billing und Plan-Verwaltungsseiten für diese Instanz.',
	'settings.instance.dailyBriefing': 'Tägliches Briefing',
	'settings.instance.webSearch': 'Websuche',
	'settings.instance.lobbyregister': 'Lobbyregister',
	'settings.instance.lobbyregister.description':
		'Lobbyregister-Suche als Sekundärquelle. Registrierte Interessenvertreter und ihre Auftraggeber aus dem Lobbyregister des Bundestags.',
	'settings.instance.fragdenstaat': 'FragDenStaat',
	'settings.instance.fragdenstaat.description':
		'FragDenStaat-Suche als Sekundärquelle. IFG-Anfragen an deutsche Behörden.',
	'settings.instance.abgeordnetenwatch': 'Abgeordnetenwatch',
	'settings.instance.abgeordnetenwatch.description':
		'Abgeordnetenwatch-Suche als Sekundärquelle. Profile von Abgeordneten, Nebentätigkeiten und namentliche Abstimmungen.',
	'settings.instance.generalSettings': 'Allgemeine Einstellungen',
	'settings.instance.systemPrompt': 'System-Prompt',
	'settings.instance.access': 'Zugang',
	'settings.instance.chatSuggestions': 'Chat-Vorschläge',
	'settings.instance.chatSuggestions.description':
		'Vorschläge erscheinen als klickbare Bubbles auf der Neuen-Chat-Seite',
	'settings.instance.chatSuggestions.placeholder': 'Vorschlag eingeben...',
	'settings.instance.chatSuggestions.add': 'Hinzufügen',
	'settings.instance.chatSuggestions.empty': 'Noch keine Vorschläge hinzugefügt',
	'settings.instance.knowledgeBase.flag': 'Wissensbasis',
	'settings.instance.knowledgeBase.flag.description':
		'Aktiviert Zugriff auf Vektorsuche, Volltextsuche und Dokumentenabruf.',
	'settings.instance.knowledgeBase.citationEngine': 'Strikte Zitate',
	'settings.instance.knowledgeBase.citationEngine.description':
		'Verlangt vom Agenten, Quellen mit exakten Zitaten zu belegen. Deaktivieren für Assistenten ohne strenge Quellenangaben.',
	'settings.instance.dailyBriefing.description': 'Unterseite "Tägliches Briefing" ist sichtbar.',
	'settings.instance.webSearch.description':
		'Websuche als Sekundärquelle für ergänzende Informationen.',
	'settings.instance.webSearch.alwaysOn': 'Immer aktiv',
	'settings.instance.webSearch.alwaysOn.description':
		'Websuche ist immer aktiv. Der Umschalter im Chat-Eingabefeld wird ausgeblendet.',
	'settings.instance.queryClassification': 'Anfrageklassifikation',
	'settings.instance.queryClassification.description':
		'Klassifiziert Anfragen vor der Verarbeitung, um Retrieval und Thinking bei einfachen Anfragen zu überspringen. Deaktivieren für Modelle mit adaptivem Thinking.',
	'settings.instance.blockedSearchDomains': 'Blockierte Suchdomains',
	'settings.instance.blockedSearchDomains.description':
		'Diese Domains aus den Websuche-Ergebnissen ausschließen, getrennt durch Kommas oder Zeilenumbrüche. Leer lassen, um alle Domains zu erlauben.',
	'settings.instance.blockedSearchDomains.placeholder': 'z.B. wikipedia.org',
	'settings.instance.welcomeMessage': 'Willkommensnachricht',
	'settings.instance.welcomeMessage.description':
		'Individuelle Willkommensnachricht auf der neuen Chat-Seite. Leer lassen für den Standard.',
	'settings.instance.defaultModel': 'Standard-Modell',
	'settings.instance.attachments.enabled': 'Anhänge im Chat',
	'settings.instance.attachments.enabled.description':
		'Nutzer können ihren Nachrichten Bilder, PDFs, Word-, PowerPoint- und Excel-Dateien und Textdateien anhängen. Dokumente werden mit Mistral OCR gelesen.',
	'settings.instance.ipUsageLimit.disabled': 'Nutzungslimit pro IP deaktivieren',
	'settings.instance.ipUsageLimit.disabled.description':
		'Anonyme Besucher im einbettbaren Widget dieser Instanz werden normalerweise begrenzt, sobald ihre IP-Adresse 500 Credits verbraucht hat. Für vertrauenswürdige Einsätze (z. B. ein betreuter Kiosk oder eine Veranstaltung), bei denen anonymer Missbrauch kein Problem darstellt, kann dies deaktiviert werden.',
	'settings.instance.antonioMode.enabled': 'Antonio-Instanz',
	'settings.instance.antonioMode.enabled.description':
		'Macht diese Instanz zu einem anonymen, geführten Chat-Erlebnis im Antonio-Stil mit eingeschränktem Toolset (Buttons/Eingaben, Bildgenerierung) statt des regulären Wissensbasis-Chats. Kann nach dem Erstellen der Instanz nicht mehr geändert werden.',
	'settings.instance.antonio.evalFunnel': 'Eval-Funnel',
	'settings.instance.autoAuth': 'Chat ohne Anmeldung erlauben',
	'settings.instance.autoAuth.description':
		'Jeder mit dem Link kann chatten, ohne sich anzumelden. Nützlich, um bei einer Veranstaltung einen Link weiterzugeben. Jederzeit deaktivierbar, um neue Besucher sofort zu blockieren.',
	'settings.instance.antonioSteps.description':
		'Fragen, die Besucher vor dem Chat durch Auswahl beantworten. Die KI bekommt die Auswahl als Fakten.',
	'settings.instance.antonioSteps.question': 'Frage',
	'settings.instance.antonioSteps.selectionMode': 'Auswahl',
	'settings.instance.antonioSteps.singleSelect': 'Einfachauswahl',
	'settings.instance.antonioSteps.multiSelect': 'Mehrfachauswahl',
	'settings.instance.antonioSteps.maxSelect': 'Wie viele Optionen Besucher wählen dürfen',
	'settings.instance.antonioSteps.optionLabel': 'Option',
	'settings.instance.antonioSteps.promptContext':
		'Hintergrund für die KI (für Besucher nicht sichtbar)',
	'settings.instance.antonioSteps.addOption': 'Option hinzufügen',
	'settings.instance.antonioSteps.removeOption': 'Option entfernen',
	'settings.instance.antonioSteps.addStep': 'Schritt hinzufügen',
	'settings.instance.antonioSteps.removeStep': 'Schritt entfernen',
	'settings.instance.antonioSteps.moveUp': 'Nach oben',
	'settings.instance.antonioSteps.moveDown': 'Nach unten',
	'settings.instance.referenceImages': 'Referenzbilder',
	'settings.instance.referenceImages.description':
		'Fotos realer Orte, auf denen das generierte Bild basiert. Ein eigenes Bild des Besuchers ersetzt sie.',
	'settings.instance.referenceImages.mode': 'Anzahl der Referenzbilder',
	'settings.instance.referenceImages.mode.single': 'Ein Referenzbild',
	'settings.instance.referenceImages.mode.single.description':
		'Jedes generierte Bild basiert darauf. Besucher wählen nichts aus.',
	'settings.instance.referenceImages.mode.single.deletesOthers':
		'Beim Speichern werden die anderen {{n}} Referenzbilder gelöscht. Wechsle zurück zu mehreren, um sie zu behalten.',
	'settings.instance.referenceImages.mode.multiple': 'Mehrere Referenzbilder',
	'settings.instance.referenceImages.mode.multiple.description':
		'Fügt vor dem Interview einen Auswahlschritt hinzu, in dem Besucher eines davon nach Namen wählen.',
	'settings.instance.referenceImages.mode.multiple.tooFew':
		'Füge mindestens zwei hinzu oder wechsle zu einem einzelnen Referenzbild.',
	'settings.instance.referenceImages.mode.hint':
		'Abwechslung ohne Auswahlschritt? Nutze ein einzelnes Referenzbild mit mehreren Fotos. Jedes Gespräch bekommt zufällig eines davon.',
	'settings.instance.referenceImages.name':
		'Name (danach wählen Besucher aus, die Galerie zeigt ihn als Ort)',
	'settings.instance.referenceImages.photos': 'Fotos (pro Gespräch wird eines zufällig gewählt)',
	'settings.instance.referenceImages.photo': 'Foto {{n}}',
	'settings.instance.referenceImages.addPhoto': 'Foto hinzufügen',
	'settings.instance.referenceImages.removePhoto': 'Foto entfernen',
	'settings.instance.referenceImages.add': 'Referenzbild hinzufügen',
	'settings.instance.referenceImages.remove': 'Referenzbild entfernen',

	'settings.instance.antonioFunnel.description':
		'Alles, was Besucher durchlaufen, von oben nach unten. Schritte lassen sich an- und ausschalten, die Vorschau zeigt jeweils, was Besucher sehen.',
	'settings.instance.antonioFunnel.welcome': 'Begrüßung',
	'settings.instance.antonioFunnel.welcome.description': 'Das Erste, was Besucher sehen.',
	'settings.instance.antonioFunnel.welcomeDisplay': 'Willkommensnachricht anzeigen als',
	'settings.instance.antonioFunnel.welcomeDisplay.message': 'Chatnachricht',
	'settings.instance.antonioFunnel.welcomeDisplay.screen': 'Startbildschirm',
	'settings.instance.antonioFunnel.welcomeDisplay.description':
		'Als Chatnachricht beginnt der Chat sofort mit der Willkommensnachricht. Auf einem Startbildschirm lesen Besucher sie zuerst und tippen auf Start, um zu beginnen.',
	'settings.instance.antonioFunnel.referenceImageChoice': 'Auswahl des Referenzbilds',
	'settings.instance.antonioFunnel.referenceImageChoice.description':
		'Besucher wählen eines der Referenzbilder aus. Der Assistent fragt danach, beschreibe die Frage also im Primer.',
	'settings.instance.antonioFunnel.choiceSteps': 'Auswahlschritte',
	'settings.instance.antonioFunnel.choiceStep': 'Auswahl {{n}}',
	'settings.instance.antonioFunnel.editStep': 'Bearbeiten',
	'settings.instance.antonioFunnel.doneEditing': 'Fertig',
	'settings.instance.antonioFunnel.interview': 'Interview',
	'settings.instance.antonioFunnel.interview.description':
		'Der Assistent stellt die Fragen aus dem Primer einzeln und fasst dann zusammen, was er verstanden hat.',
	'settings.instance.antonioFunnel.interview.editPrimer': 'Primer bearbeiten',
	'settings.instance.antonioFunnel.generate': 'Bildgenerierung',
	'settings.instance.antonioFunnel.generate.description':
		'Der Assistent schreibt aus dem Gespräch einen Bild-Prompt und bearbeitet damit ein Referenzbild: bei mehreren das gewählte. Ein eigenes Bild des Besuchers ersetzt es.',
	'settings.instance.antonioFunnel.end': 'Ende',
	'settings.instance.antonioFunnel.end.description':
		'Was Besucher tun können, sobald ihr Bild veröffentlicht ist.',
	'settings.instance.antonioFunnel.end.gallerySettings': 'Galerie-Einstellungen',
	'settings.instance.antonioFunnel.galleryLink': 'Link zum Bild in der Galerie',
	'settings.instance.antonioFunnel.galleryLink.description':
		'Zeigt einen Button, der das veröffentlichte Bild in der öffentlichen Galerie öffnet.',
	'settings.instance.antonioFunnel.galleryLink.galleryDisabled':
		'Die Galerie ist nicht aktiviert, daher sehen Besucher diesen Button noch nicht.',
	'settings.instance.antonioFunnel.feedback': 'Nach Feedback fragen',
	'settings.instance.antonioFunnel.feedback.description':
		'Zeigt einen Feedback-Button, der zum gewählten Eval-Funnel führt. Im Live-Chat noch nicht sichtbar.',

	'settings.instance.antonioChat.autoReset': 'Automatisch zurücksetzen',
	'settings.instance.antonioChat.autoReset.description':
		'Wenn aktiviert, wird die Chat-Sitzung nach einigen Minuten Inaktivität automatisch zurückgesetzt.',
	'settings.instance.antonioChat.allowChanges': 'Änderungen erlauben',
	'settings.instance.antonioChat.allowChanges.description':
		'Wenn aktiviert, können Besucher vor der Generierung noch etwas ergänzen und statt des Speicherns Änderungen am Bild verlangen. Wenn deaktiviert, sind alle "Noch nicht"-Buttons ausgeblendet, jeder Besucher bekommt also genau ein Bild.',
	'settings.instance.antonioChat.showEmailInput': 'E-Mail-Eingabe anzeigen',
	'settings.instance.antonioChat.showEmailInput.description':
		'Wenn aktiviert, darf der Assistent Nutzer während des Gesprächs nach ihrer E-Mail-Adresse fragen.',
	'settings.instance.antonioChat.showNewsletterCheckbox': 'Newsletter-Checkbox anzeigen',
	'settings.instance.antonioChat.showNewsletterCheckbox.description':
		'Wenn aktiviert, wird Nutzern bei Angabe ihrer E-Mail-Adresse eine Newsletter-Opt-in-Checkbox angezeigt.',
	'settings.instance.antonioChat.collectContactInfo': 'Kontaktdaten erfassen',
	'settings.instance.antonioChat.collectContactInfo.description':
		'Wenn aktiviert, fragt der Assistent vor der Veröffentlichung des Bildes nach Name (und E-Mail, falls aktiviert) des Nutzers. Wenn deaktiviert, werden keine persönlichen Daten erfasst; der Assistent fragt stattdessen, ob das Bild veröffentlicht werden soll.',
	'settings.instance.antonioChat.collectImage': 'Nach einem Bild fragen',
	'settings.instance.antonioChat.collectImage.description':
		'Wenn aktiviert, fragt der Assistent vor der Generierung nach einem eigenen Bild des Besuchers und nutzt dieses als Referenz anstelle des Referenzbilds der Instanz. Besucher können auch ohne Bild fortfahren.',
	'settings.instance.antonioChat.userProvidedImageGuidance': 'Hinweise zum Bild',
	'settings.instance.antonioChat.userProvidedImageGuidance.description':
		'Teilt dem Assistenten mit, was Besucher hochladen, zum Beispiel dass es ein Selfie ist, dessen Ähnlichkeit erhalten bleiben muss. Ergänzt die allgemeinen Regeln für das Bearbeiten eines ungesehenen Bildes, die immer gelten. Leer lassen, wenn der Upload keine besondere Behandlung braucht.',
	'settings.instance.antonioChat.imageFormat': 'Bildformat',
	'settings.instance.antonioChat.imageFormat.description':
		'Seitenverhältnis des generierten Bildes. Hoch- und Querformat nutzen das DIN-A-Verhältnis und lassen sich daher ohne Beschnitt auf A6 oder A5 drucken.',
	'settings.instance.antonioChat.imageFormat.square': 'Quadratisch',
	'settings.instance.antonioChat.imageFormat.portrait': 'Hochformat',
	'settings.instance.antonioChat.imageFormat.landscape': 'Querformat',
	'settings.instance.antonioChat.imageModel': 'Bildmodell',
	'settings.instance.antonioChat.imageResolution': 'Auflösung',
	'settings.instance.antonioChat.imageResolution.description':
		'Flux 3 berechnet einen festen Preis pro Bild, abhängig von der Auflösung. 1K hat etwa 1 Megapixel und reicht fürs Web. 2K hat etwa 4 Megapixel für scharfe Drucke und kostet etwa doppelt so viel. Hoch- und Querformat rendert Flux 3 im Verhältnis 5:7, etwa 1 % neben DIN A, daher fällt beim Druck ein schmaler Rand weg.',
	'settings.instance.antonioChat.aiLabel': 'KI-Hinweis auf Bildern',
	'settings.instance.antonioChat.aiLabel.description':
		'Setzt "KI-generiert mit" und den Namen des Assistenten unten rechts auf jedes neue Bild, in der eingestellten Sprache, und kennzeichnet die Datei in ihren Metadaten als KI-generiert. Bereits erstellte Bilder bleiben unverändert.',
	'settings.instance.antonioChat.avatar': 'Avatar',
	'settings.instance.antonioChat.assistantName': 'Name des Assistenten',
	'settings.instance.antonioChat.assistantName.description':
		'Der Name, der Nutzern im Chat angezeigt wird (z. B. "Chat mit Antonio"). Leer lassen, um den Standardnamen "Antonio" zu verwenden.',

	'settings.instance.gallery.enabled': 'Galerie aktivieren',
	'settings.instance.gallery.enabled.description':
		'Macht die Galerie über ihren direkten Link öffentlich erreichbar, ohne sie auf der öffentlichen Galerie-Seite aufzulisten.',
	'settings.instance.gallery.listed': 'Auf Galerie-Seite anzeigen',
	'settings.instance.gallery.listed.description':
		'Zeigt diese Ausstellung zusätzlich zur Erreichbarkeit über ihren direkten Link auch auf der öffentlichen Galerie-Seite an.',
	'settings.instance.gallery.online': 'Online-Ausstellung',
	'settings.instance.gallery.online.description':
		'Markiert diese Ausstellung als rein online (kein physischer Veranstaltungsort), sie wird in einem eigenen Bereich auf der öffentlichen Galerie-Seite angezeigt.',
	'settings.instance.gallery.link': 'Link',
	'settings.instance.gallery.venue': 'Veranstaltungsort',
	'settings.instance.gallery.start': 'Start',
	'settings.instance.gallery.end': 'Ende',
	'settings.instance.gallery.description': 'Beschreibung',
	'settings.instance.gallery.logo': 'Logo',

	'antonio.chatHeader': 'Chat mit {{name}}',
	'antonio.avatarAlt': '{{name}}-Avatar',
	'antonio.onboarding.start': 'Start',
	'antonio.contact.namePlaceholder': 'Dein Name',
	'antonio.contact.emailPlaceholder': 'E-Mail-Adresse (optional)',
	'antonio.contact.newsletterOptIn':
		'Bitte schickt mir zusätzlich gelegentlich Neuigkeiten (Newsletter) zu weiteren KI-Projekten von euch.',
	'antonio.contact.submitted.name': 'Ich habe meinen Namen angegeben.',
	'antonio.contact.submitted.nameEmail':
		'Ich habe meinen Namen und meine E-Mail-Adresse angegeben.',
	'antonio.startOver': 'Neu starten',
	'antonio.generateConfirm.yes.label': 'Ja, generieren!',
	'antonio.generateConfirm.yes.value': 'Ja, bitte generiere jetzt das Bild.',
	'antonio.generateConfirm.no.label': 'Noch nicht',
	'antonio.generateConfirm.no.value': 'Noch nicht, ich möchte vorher noch etwas ergänzen.',
	'antonio.image.choose': 'Bild aufnehmen oder hochladen',
	'antonio.image.change': 'Anderes Bild wählen',
	'antonio.image.use': 'Dieses Bild verwenden',
	'antonio.image.skip': 'Ohne Bild fortfahren',
	'antonio.image.hint':
		'Dein Upload wird nur zur Generierung des Bildes verwendet und danach gelöscht.',
	'antonio.image.uploadError':
		'Das Bild konnte nicht hochgeladen werden. Bitte versuche es erneut.',
	'antonio.publishConfirm.yes.label': 'Speichern & veröffentlichen',
	'antonio.publishConfirm.yes.value': 'Ja, bitte speichere und veröffentliche dieses Bild.',
	'antonio.publishConfirm.no.label': 'Noch nicht',
	'antonio.publishConfirm.no.value': 'Ich möchte vorher noch Änderungen am Bild vornehmen.',
	'antonio.generatingImage': 'Ich generiere jetzt das Bild, das kann ein paar Sekunden dauern...',
	'antonio.viewInGallery': 'Bild ansehen',
	'antonio.chat.retryButton': 'Erneut versuchen',
	'antonio.choice.confirm': 'Weiter',
	'antonio.choice.hint': 'Bis zu {{max}} auswählen',

	'settings.instance.nav.header': 'Admin-Einstellungen',
	'settings.instance.nav.back': 'Zurück',
	'settings.instance.nav.instanceSection': 'Instanz-Einstellungen',
	'settings.instance.nav.general': 'Allgemein',
	'settings.instance.nav.knowledgeBase': 'Wissensbasis',
	'settings.instance.nav.secondarySources': 'Sekundärquellen',
	'settings.instance.nav.queryClassification': 'Anfrageklassifikation',
	'settings.instance.nav.imageGeneration': 'Bildgenerierung',
	'settings.instance.nav.antonioAssistant': 'Assistent',
	'settings.instance.nav.antonioFunnel': 'Funnel',
	'settings.instance.nav.antonioReferenceImages': 'Referenzbilder',
	'settings.instance.nav.antonioGallery': 'Galerie',
	'settings.instance.nav.chatSuggestions': 'Chat-Vorschläge',
	'settings.instance.nav.apiKeys': 'API-Keys',
	'settings.instance.nav.billing': 'Billing',
	'settings.instance.nav.systemHealth': 'Systemstatus',
	'settings.instance.nav.news': 'News',
	'settings.instance.nav.antonioSection': 'Antonio',
	'settings.instance.nav.featuresSection': 'Funktionen',
	'settings.instance.nav.systemSection': 'System',
	'settings.instance.unsavedChanges': 'Ungespeicherte Änderungen',
	'settings.instance.unsavedChanges.title': 'Änderungen verwerfen?',
	'settings.instance.unsavedChanges.message':
		'Du hast ungespeicherte Änderungen auf dieser Seite. Sie gehen verloren, wenn du die Seite verlässt.',
	'settings.instance.unsavedChanges.discard': 'Verwerfen',

	'settings.instance.imageGeneration.enabled': 'Bildgenerierung aktivieren',
	'settings.instance.imageGeneration.enabled.description':
		'Erlaubt dem Chat-Assistenten, auf Anfrage Bilder zu generieren (über das generate_image-Tool).',
	'settings.instance.imageGeneration.model': 'Bildmodell',

	'news.center': 'News Center',
	'news.noItems': 'Keine Neuigkeiten',
	'news.new': 'Neue Neuigkeit',
	'news.title': 'Titel',
	'news.body': 'Inhalt',
	'news.ctaLabel': 'Button-Beschriftung',
	'news.ctaHref': 'Button-Link',
	'news.showFrom': 'Anzeigen ab',
	'news.showUntil': 'Anzeigen bis',
	'news.edit': 'Neuigkeit bearbeiten',
	'news.delete.confirm': 'Neuigkeit löschen',
	'news.delete.question': 'Möchtest du diese Neuigkeit wirklich löschen?',

	'settings.instance.systemHealth.basic': 'Einfacher Health Check',
	'settings.instance.systemHealth.basic.description':
		'Prüft, ob der RAG-Service und seine Datenbankverbindung erreichbar sind. Gleicher Check wie das automatische Monitoring.',
	'settings.instance.systemHealth.extended': 'Erweiterter Health Check',
	'settings.instance.systemHealth.extended.description':
		'Führt eine Testanfrage an jedes verfügbare KI-Modell sowie den Embedding- und Reranking-Service aus. Dabei entstehen echte Modellaufrufe, der Check kann bis zu einer Minute dauern.',
	'settings.instance.systemHealth.run': 'Check ausführen',
	'settings.instance.systemHealth.status.ok': 'Alle Checks bestanden',
	'settings.instance.systemHealth.status.degraded': 'Einige Checks fehlgeschlagen',

	'settings.instance.defaultClassification': 'Standard-Klassifikation',
	'settings.instance.defaultClassification.description':
		'Verhalten wenn die Anfrageklassifikation deaktiviert ist. Diese Einstellungen bestimmen wie jede Anfrage behandelt wird.',
	'settings.instance.defaultClassification.enableThinking': 'Thinking aktivieren',
	'settings.instance.defaultClassification.hideThinking': 'Gedanken ausblenden',
	'settings.instance.defaultClassification.enableTools': 'Tools aktivieren',
	'settings.instance.defaultClassification.temperature': 'Temperatur',
	'settings.instance.defaultClassification.maxIterations': 'Max. Iterationen',

	'instance.create.title': 'Neue Instanz',
	'instance.create.name': 'Instanz-Name',
	'instance.create.slug': 'Slug (URL-Kennung)',
	'instance.create.language': 'Sprache',
	'instance.create.type': 'Instanz-Typ',
	'instance.create.type.standard': 'Standard',
	'instance.create.type.standard.description':
		'Regulärer authentifizierter Chat mit dem vollen konfigurierbaren Tool-Set.',
	'instance.create.type.antonio': 'Antonio',
	'instance.create.type.antonio.description':
		'Anonyme, geführte Chat-Erfahrung im Antonio-Stil mit eingeschränktem Tool-Set (Buttons/Eingaben, Bildgenerierung) statt des regulären Wissensdatenbank-Chats. Kann nach dem Erstellen der Instanz nicht mehr geändert werden.',
	'instance.create.submit': 'Instanz erstellen',
	'instance.duplicate.title': 'Instanz duplizieren',
	'instance.duplicate.description':
		'Erstellt eine neue Instanz mit den gespeicherten Einstellungen dieser Instanz, inklusive Kopien der Referenzbilder und des Logos. Nutzer, API-Keys, Unterhaltungen und Bilder bleiben beim Original. In der Kopie sind die Galerie und der Chat ohne Anmeldung zunächst ausgeschaltet.',
	'instance.duplicate.copyName': '{{name}} (Kopie)',
	'instance.duplicate.submit': 'Duplizieren',
	'instance.picker.title': 'Instanz wechseln',
	'instance.picker.search': 'Nach Name oder Slug suchen',
	'instance.picker.empty': 'Keine Instanz passt zu deiner Suche.',
	'instance.picker.galleryLive': 'Galerie live',
	'instance.picker.created': 'Erstellt am {{date}}',

	'apiKeys.title': 'API Keys',
	'apiKeys.createNew': 'Neuen Key erstellen',
	'apiKeys.noKeys': 'Noch keine API Keys. Erstelle einen, um loszulegen.',
	'apiKeys.active': 'Aktiv',
	'apiKeys.inactive': 'Inaktiv',
	'apiKeys.created': 'Erstellt',
	'apiKeys.lastUsed': 'Zuletzt verwendet',
	'apiKeys.expires': 'Läuft ab',
	'apiKeys.neverExpires': 'Läuft nie ab',
	'apiKeys.requests': 'Anfragen',
	'apiKeys.createdBy': 'Besitzer',
	'apiKeys.anonymousConversations': 'Anonyme Konversationen',
	'apiKeys.deleteConfirm': 'Möchtest du den API Key "{{name}}" wirklich löschen?',

	'sharedLinks.title': 'Geteilte Links',
	'sharedLinks.createNew': 'Geteilten Link erstellen',
	'sharedLinks.noLinks': 'Noch keine geteilten Links. Erstelle einen, um loszulegen.',
	'sharedLinks.deleteConfirm': 'Möchtest du diesen geteilten Link wirklich löschen?',
	'sharedLinks.create.title': 'Geteilten Link erstellen',
	'sharedLinks.create.generating': 'Geteilten Link wird erstellt...',

	'apiKeys.create.title': 'API Key erstellen',
	'apiKeys.create.keyName': 'Key-Name',
	'apiKeys.create.keyType': 'Key-Typ',
	'apiKeys.create.keyType.widget': 'Widget',
	'apiKeys.create.keyType.sharedLink': 'Geteilter Link',
	'apiKeys.create.keyType.api': 'API / Integration',
	'apiKeys.create.allowedOrigins': 'Erlaubte Origins (kommagetrennt)',
	'apiKeys.create.validityPeriod': 'Gültigkeitsdauer',
	'apiKeys.create.neverExpires': 'Läuft nie ab',
	'apiKeys.create.days': '{{count}} Tage',
	'apiKeys.create.year': '1 Jahr',
	'apiKeys.create.anonymousConversations': 'Anonyme Konversationen',
	'apiKeys.create.anonymousConversationsHelp':
		'Konversationen haben keinen Besitzer und erscheinen nicht in der Konversationsliste des Key-Erstellers.',
	'apiKeys.create.submit': 'Key erstellen',
	'apiKeys.create.warning':
		'Stelle sicher, dass du deinen API Key jetzt kopierst. Du wirst ihn nicht noch einmal sehen können!',
	'apiKeys.create.copyToClipboard': 'In Zwischenablage kopieren',
	'apiKeys.create.done': 'Fertig',
	'apiKeys.create.sharedLinkSuccess': 'Teile diesen Link mit anderen:',

	'onboarding.title': 'Willkommen!',
	'onboarding.getStarted': "Los geht's",
	'onboarding.showDialog': 'Willkommensdialog anzeigen',

	'plan.free': 'Free',
	'plan.essential': 'Essential',
	'plan.pro': 'Pro',
	'plan.conversations': '{{current}}/{{max}} Chats',
	'plan.conversationsUnlimited': 'Unbegrenzte Chats',
	'plan.usageWarning': '{{percent}}% des monatlichen Kontingents verbraucht',
	'plan.usingExtraCredits': 'Zusätzliche Credits werden verwendet',
	'plan.quotaExhausted': 'Chat-Kontingent aufgebraucht',
	'plan.extraCreditsInUse':
		'Inklusives Chat-Kontingent aufgebraucht. Zusatz-Credits werden verbraucht ({{count}} übrig)',
	'plan.creditsExhausted': 'Alle Credits aufgebraucht — Upgrade erforderlich',
	'plan.upgrade': 'Upgrade',
	'plan.upgrade.title': 'Plan verwalten',
	'plan.upgrade.description':
		'Erhalte mehr Chats und Nachrichten pro Chat durch ein Upgrade deines Plans.',
	'plan.upgrade.currentPlan': 'Aktueller Plan',
	'plan.upgrade.features': 'Features',
	'plan.upgrade.conversationsLimit': '{{count}} Chats',
	'plan.upgrade.conversationsUnlimited': 'Unbegrenzte Chats',
	'plan.upgrade.messagesLimit': '{{count}} Nachrichten pro Chat',
	'plan.upgrade.messagesUnlimited': 'Unbegrenzte Nachrichten pro Chat',
	'plan.upgrade.essentialDescription':
		'Das Wesentliche für Monitoring und parlamentarische Recherche',
	'plan.upgrade.proDescription': 'Das volle ParlamentAI-Erlebnis für Power-User',
	'plan.upgrade.higherUsageLimitsThanEssential': 'Höhere Nutzungslimits als Essential',
	'billing.checkout.taxOnBillingDetails': 'Steuer wird anhand deiner Rechnungsadresse berechnet',
	'plan.upgrade.earlyAdopterTitle': 'Early Adopter Bonus',
	'plan.upgrade.earlyAdopterDescription':
		'Als Dankeschön für deine frühe Anmeldung bei Botbakery: Verdopple deine Limits kostenlos!',
	'plan.upgrade.claimBonus': 'Bonus einlösen',
	'plan.upgrade.comingSoon': 'Demnächst verfügbar',
	'plan.upgrade.contact': 'Kontaktiere uns',
	'plan.upgrade.contactDescription': 'Interesse an einem Upgrade? Melde dich bei uns.',
	'billing.upgradePlan': 'Plan upgraden',
	'billing.upgrade': 'Auswählen',
	'billing.upgrade.trialHint': 'kostenlos testen',
	'billing.upgrade.customAlternativeTitle': 'Brauchst du eine individuelle Instanz?',
	'billing.upgrade.customAlternativeBody':
		'Melde dich bei uns, wir richten ParlamentAI passend für deine Organisation ein.',
	'billing.manageBilling': 'Abrechnung verwalten',
	'billing.monthly': 'Monatlich zahlen',
	'billing.yearly': 'Jährlich zahlen',
	'billing.priceFrom': 'ab',
	'billing.perMonth': 'Monat',
	'billing.perYear': 'Jahr',
	'billing.savePercent': '{{percent}}% sparen',
	'billing.priceNA': 'n/a',
	'billing.vatDisclaimer': 'Alle Preise zzgl. 19% MwSt.',
	'billing.compareAbos': 'Alle Abo-Details vergleichen',
	'billing.renewsOn': 'Nächste Zahlung am {{date}}',
	'billing.cancelsOn': 'Endet am {{date}}',
	'billing.trialEndsOn':
		'Testphase endet am {{date}}. Danach wird dir der Betrag berechnet, wenn du nicht vorher kündigst.',
	'billing.status.active': 'Aktiv',
	'billing.status.trialing': 'Testphase',
	'billing.status.cancelled': 'Gekündigt',
	'billing.nonBilled.info': 'Dieser Plan wird dir derzeit nicht in Rechnung gestellt.',
	'billing.customBilled.info': 'Dein Plan wird per Rechnung abgerechnet.',
	'billing.upgrade.successMessage': 'Upgrade erfolgreich! Willkommen bei Pro.',
	'billing.upgrade.canceledMessage': 'Checkout abgebrochen. Dein Plan bleibt unverändert.',
	'billing.upgrade.creditsAlternativeTitle': 'Kein Abo gewünscht?',
	'billing.upgrade.creditsAlternativeBody':
		'Kaufe Credits und zahle nur für das, was du nutzt, ohne monatliche Bindung.',
	'billing.upgrade.buyCreditsInstead': 'Credits kaufen',
	'billing.form.title': 'Zahlungsmethode',
	'billing.form.subscribe': 'Abonnieren',
	'billing.form.savePaymentMethod': 'Zahlungsmethode speichern',
	'billing.form.processing': 'Wird verarbeitet…',
	'billing.form.intentError':
		'Zahlungssession konnte nicht erstellt werden. Bitte versuche es erneut.',
	'billing.form.stripeLoadError':
		'Zahlungsformular konnte nicht geladen werden. Bitte versuche es erneut.',
	'billing.form.genericError': 'Zahlung fehlgeschlagen. Bitte versuche es erneut.',
	'billing.form.email': 'Rechnungs-E-Mail',
	'billing.form.billingAddress': 'Rechnungsadresse',
	'billing.form.region': 'Land',
	'billing.form.addressLine1': 'Straße + Hausnummer',
	'billing.form.postalCode': 'Postleitzahl',
	'billing.form.city': 'Ort',
	'billing.form.vatId': 'USt-IdNr. (optional)',
	'billing.form.vatIdPlaceholder': 'z.B. DE123456789',
	'billing.form.vatIdInvalid': 'Ungültige USt-IdNr.',
	'billing.form.addressIncomplete': 'Bitte Rechnungsadresse vollständig ausfüllen.',
	'billing.form.paymentMethodSaved': 'Zahlungsmethode gespeichert.',
	'billing.addPaymentMethod': 'Zahlungsmethode hinzufügen',
	'billing.updatePaymentMethod': 'Zahlungsmethode aktualisieren',
	'billing.details.title': 'Rechnungsdaten',
	'billing.details.name': 'Vollständiger Name / Firmenname',
	'billing.details.save': 'Speichern',
	'billing.details.saving': 'Wird gespeichert…',
	'billing.details.saved': 'Rechnungsdaten gespeichert.',
	'billing.details.error':
		'Rechnungsdaten konnten nicht gespeichert werden. Bitte versuche es erneut.',
	'billing.details.addressIncomplete': 'Bitte Rechnungsadresse vollständig ausfüllen.',
	'billing.details.missingRequired': 'Bitte Name und Rechnungs-E-Mail eingeben.',
	'billing.payment.title': 'Zahlungsmethode',
	'billing.payment.expires': 'Gültig bis {{date}}',
	'billing.payment.changeCard': 'Karte ändern',
	'billing.payment.saveCard': 'Karte speichern',
	'billing.payment.saving': 'Wird gespeichert…',
	'billing.payment.saved': 'Zahlungsmethode gespeichert.',
	'billing.payment.stripeLoadError':
		'Zahlungsformular konnte nicht geladen werden. Bitte versuche es erneut.',
	'billing.payment.intentError':
		'Zahlungssession konnte nicht erstellt werden. Bitte versuche es erneut.',
	'billing.payment.genericError':
		'Karte konnte nicht gespeichert werden. Bitte versuche es erneut.',
	'billing.checkout.title': 'Checkout',
	'billing.checkout.subscribe': 'Zahlungspflichtig Abonnieren',
	'billing.checkout.subscribing': 'Wird abonniert…',
	'billing.checkout.subscribeError':
		'Abo konnte nicht abgeschlossen werden. Bitte versuche es erneut.',
	'billing.checkout.noPaymentMethod': 'Füge eine Zahlungsmethode hinzu, um zu abonnieren.',
	'billing.checkout.paymentMethodReady': 'Zahlungsmethode bereit.',
	'billing.checkout.orderSummary': 'Bestellübersicht',
	'billing.checkout.net': 'Zwischensumme',
	'billing.checkout.vatAmount': 'MwSt. (19%)',
	'billing.checkout.total': 'Gesamt',
	'billing.checkout.totalPerMonth': 'Gesamt pro Monat',
	'billing.checkout.totalPerYear': 'Gesamt pro Jahr',
	'billing.checkout.dueToday': 'Heute fällig',
	'billing.checkout.startsImmediately': 'Abonement beginnt sofort',
	'billing.checkout.nextMonthlyCharge': 'Nächste monatliche Abbuchung: {{date}}',
	'billing.checkout.nextAnnualCharge': 'Nächste jährliche Abbuchung: {{date}}',
	'billing.checkout.cancelAnytime': 'Du kannst dein Abo jederzeit kündigen.',
	'billing.checkout.acceptTermsBefore':
		'Mit Klick auf den Button unten bestätigst du, dass du unserer ',
	'billing.checkout.acceptTermsBetween': ' und dem ',
	'billing.checkout.acceptTermsAfter': ' zustimmst.',
	'billing.checkout.upgrade': 'Zahlungspflichtig upgraden',
	'billing.checkout.upgradeError': 'Upgrade fehlgeschlagen. Bitte versuche es erneut.',
	'billing.checkout.startTrial': 'Kostenlos testen',
	'billing.checkout.trialFineprint':
		'Dein 7-tägiger kostenloser Testzeitraum beginnt heute. Am {{date}} wird dir {{amount}} berechnet, wenn du nicht vorher kündigst.',
	'billing.checkout.alreadyOnPlan':
		'Du versuchst den {{selectedPlan}}-Plan zu buchen, hast aber bereits den {{currentPlan}}-Plan.',
	'billing.checkout.proratedChargeNew': 'Neues Abo (anteilig)',
	'billing.checkout.proratedCreditOld': 'Guthaben bisheriges Abo',
	'billing.checkout.creditBalance': 'Guthaben für nächste Rechnung',
	'billing.checkout.proratedNote':
		'Ein anteiliger Betrag für die verbleibenden Tage deines Abrechnungszeitraums wird sofort berechnet.',
	'billing.checkout.successTitle': 'Abo aktiv',
	'billing.checkout.successMessage': 'Du hast erfolgreich ParlamentAI {{plan}} abonniert.',
	'billing.checkout.successTitleTrial': 'Testzeitraum gestartet',
	'billing.checkout.successMessageTrial':
		'Dein 7-tägiger kostenloser Testzeitraum hat begonnen. Du hast jetzt vollen Zugriff auf ParlamentAI {{plan}}.',
	'billing.checkout.successCta': "Los geht's",
	'billing.checkout.successNextSteps': 'Was du jetzt tun kannst:',
	'billing.checkout.successNewChat': 'Neuen Chat starten',
	'billing.checkout.successNewChatDesc': 'Frag zu Gesetzen, Debatten und Parlamentsvorgängen',
	'billing.checkout.successSetupBriefing': 'Persönliches Briefing einrichten',
	'billing.checkout.successSetupBriefingDesc':
		'Erhalte täglich Updates zu Themen, die dich interessieren',
	'billing.checkout.processingTitle': 'Upgrade wird verarbeitet',
	'billing.checkout.processingMessage': 'Dein Plan-Upgrade wird gerade verarbeitet…',
	'billing.checkout.processingCta': 'Neu laden',
	'billing.checkout.timeoutTitle': 'Wird noch verarbeitet…',
	'billing.checkout.timeoutMessage':
		'Dein Kauf dauert etwas länger als erwartet. Die Credits erscheinen in Kürze in deinem Konto — du kannst diese Seite schließen.',
	'settings.user.nav.general': 'Allgemein',
	'settings.user.nav.billing': 'Zahlung',
	'settings.user.nav.usage': 'Nutzung',
	'settings.user.nav.integrations': 'Integrationen',
	'settings.user.nav.communications': 'Kommunikation',
	'settings.user.communications.description':
		'Wähle aus, welche E-Mails du von uns erhalten möchtest.',
	'settings.user.communications.newsletter': 'Botbakery Newsletter',
	'settings.user.communications.newsletter.description':
		'Neuigkeiten und Updates zu Botbakery und unseren Projekten, darunter parlament.ai, neue Tools und aktuelle Entwicklungen.',
	'settings.user.communications.productUpdates': 'Produkt-Updates',
	'settings.user.communications.productUpdates.description':
		'Release-Notes und neue Funktionen der Plattform.',
	'settings.user.integrations.info':
		'Du möchtest {{instanceName}} mit {{name}} verbinden? Meld dich bei uns.',
	'settings.user.integrations.requestSetup': 'Integration anfragen',
	'settings.user.integrations.email.subject': 'Integrationsanfrage: {{name}}',
	'settings.user.integrations.email.body':
		'Hallo,\n\nwir möchten eine {{name}}-Integration für unsere Organisation einrichten lassen.\n\nBitte meldet euch, um die nächsten Schritte zu besprechen.\n\nViele Grüße',
	'settings.user.integrations.intro':
		'Verbinde {{instanceName}} mit deinen bestehenden Tools und Workflows. Integrationen sind nur im Pro-Abo verfügbar, und API-Aufrufe verbrauchen immer Nutzungskredits, unabhängig vom enthaltenen Kontingent deines Abos.',
	'settings.user.integrations.noCredits':
		'Du hast keine Nutzungskredits. API-Aufrufe verbrauchen immer Kredits aus deinem Guthaben, unabhängig vom enthaltenen Kontingent deines Abos.',
	'settings.user.integrations.about.title': 'Agent2Agent-Zugriff (A2A)',
	'settings.user.integrations.about.description':
		'{{instanceName}} stellt eine A2A-konforme (Agent2Agent) Agent Card bereit und funktioniert damit mit jedem A2A-kompatiblen Client, nicht nur den unten aufgeführten. Trage die URL unten in das Agent-Card-Feld deines Clients ein, oder nutze die Endpunkt-URL, falls dieser stattdessen danach fragt.',
	'settings.user.integrations.agentCardUrl': 'Agent-Card-URL',
	'settings.user.integrations.agentEndpointUrl': 'Endpunkt-URL',
	'settings.user.integrations.copilot.name': 'Microsoft Copilot',
	'settings.user.integrations.copilot.description':
		'Verbinde {{instanceName}} als KI-Agent in Microsoft Copilot Studio.',
	'settings.user.integrations.copilot.step1':
		'Öffne in Copilot Studio deinen Agenten und gehe zu Agents → Agent hinzufügen → Externen Agenten verbinden → Agent2Agent.',
	'settings.user.integrations.copilot.step2':
		'Trage die Endpunkt-URL von oben (nicht die Agent-Card-URL) in das Endpunkt-Feld ein.',
	'settings.user.integrations.copilot.step3':
		'Copilot Studio versucht, Name und Beschreibung automatisch aus der Agent Card zu übernehmen. Falls das nicht klappt, trage sie manuell ein.',
	'settings.user.integrations.copilot.step4':
		'Wähle eine Verbindung aus oder erstelle eine neue, setze deren Authentifizierung auf „API-Key" und trage einen Key aus dem API-Keys-Bereich unten ein.',
	'settings.user.integrations.copilot.step5':
		'Wähle „Hinzufügen und konfigurieren". {{instanceName}} steht jetzt als Agent in deinem Microsoft 365 Copilot zur Verfügung.',
	'settings.user.integrations.langdock.name': 'Langdock',
	'settings.user.integrations.langdock.description':
		'Verbinde {{instanceName}} als KI-Agent in deinem Langdock-Workspace.',
	'settings.user.integrations.langdock.step1':
		'Öffne den Bereich Integrationen im linken Menü von Langdock.',
	'settings.user.integrations.langdock.step2':
		'Klicke auf „Integration hinzufügen" → „Neu erstellen" und wähle „Remote Agent verbinden (A2A)".',
	'settings.user.integrations.langdock.step3':
		'Trage die Agent-Card-URL von oben in das Feld Agent Card URL ein. Wähle „API-Key" als Authentifizierungsmethode und trage einen Key aus dem API-Keys-Bereich unten ein.',
	'settings.user.integrations.langdock.step4':
		'Klicke auf „Erstellen". {{instanceName}} steht jetzt als KI-Agent in deinem Langdock-Workspace zur Verfügung.',
	'settings.user.integrations.apiKeys.title': 'API-Keys',
	'settings.user.integrations.apiKeys.description':
		'Erstelle API-Keys, um Integrationen mit {{instanceName}} zu authentifizieren. Jede Integration sollte einen eigenen Key verwenden.',
	'settings.user.integrations.apiKeys.noKeys':
		'Noch keine API-Keys vorhanden. Erstelle einen, um loszulegen.',
	'settings.user.integrations.setupGuide': 'Einrichtungsanleitungen',
	'settings.user.integrations.help.title': 'Noch Fragen?',
	'settings.user.integrations.help.description':
		'Fragen zur Einrichtung oder Interesse an einer individuellen Lösung? Wir helfen gerne weiter.',
	'settings.user.integrations.help.cta': 'Kontakt aufnehmen',
	'settings.user.billing.title': 'Zahlung',
	'settings.user.usage.title': 'Nutzung',
	'settings.user.usage.comingSoon': 'Nutzungsstatistiken folgen demnächst.',
	'settings.user.usage.quotas': 'Kontingente',
	'settings.user.usage.chatUsage': 'Chat',
	'settings.user.usage.briefings': 'Briefing Abos',
	'settings.user.usage.used': '{{percent}}% verwendet',
	'settings.user.usage.briefingsCount': '{{used}} / {{max}} aktiv',
	'settings.user.usage.briefingsOnlyActive': 'Nur aktive Briefings zählen',
	'settings.user.usage.briefingsNoPlan': 'Erfordert mindestens den Essential-Plan',
	'settings.user.usage.unlimited': 'Unbegrenzt',
	'settings.user.usage.resetsOn': 'Reset am {{date}}',
	'settings.user.usage.resetsDaily': 'Setzt sich täglich zurück',
	'settings.user.usage.grantBalance': 'Zusätzliche Credits',
	'settings.user.usage.grantBalanceIntro':
		'Zusätzliche Credits werden erst verwendet, wenn das im Plan enthaltene Kontingent aufgebraucht ist.',
	'settings.user.usage.grantBalanceEmpty': 'Du hast keine zusätzlichen Credits.',
	'settings.user.usage.grantBalancePurchaseBefore': 'Brauchst du mehr Credits? Schreib uns an',
	'settings.user.usage.grantBalancePurchaseAfter': '— Self-Service-Kauf ist demnächst verfügbar.',
	'settings.user.usage.grantBalanceAvailable': 'Verfügbare Credits',
	'settings.user.usage.statusWarn':
		'Du hast {{percent}}% deines monatlichen Kontingents verbraucht. Sobald du 100% erreichst, werden automatisch Zusatz-Credits verwendet, sofern vorhanden.',
	'settings.user.usage.statusExtraCredits':
		'Dein inklusives Chat-Kontingent ist aufgebraucht. Zusatz-Credits werden jetzt verbraucht ({{count}} übrig). Sie werden automatisch genutzt, bis sie aufgebraucht sind.',
	'settings.user.usage.statusExhausted':
		'Dein monatliches Kontingent ist vollständig aufgebraucht und du hast keine Zusatz-Credits mehr. Du kannst keine neuen Chats starten, bis dein Kontingent zurückgesetzt wird oder du deinen Plan upgradest.',
	'settings.user.usage.grantHistory': 'Gutschriften',
	'settings.user.usage.grantHistoryDate': 'Datum',
	'settings.user.usage.grantHistoryAmount': 'Betrag',
	'settings.user.usage.grantHistoryNote': 'Notiz',
	'common.cancel': 'Abbrechen',
	'billing.pastDue.warning': 'Zahlungsproblem festgestellt.',
	'billing.pastDue.contact':
		'Wir haben ein Problem mit deiner Zahlung bemerkt und werden uns in Kürze bei dir melden.',
	'billing.pastDue.retry': 'Zahlung wiederholen',
	'billing.pastDue.retryError': 'Zahlung konnte nicht wiederholt werden. Bitte erneut versuchen.',
	'billing.canceledGracePeriod': 'Dein Abo endet am {{date}}. Du hast bis dahin noch Pro-Zugang.',
	'billing.canceledGracePeriodNoDate':
		'Dein Abo wurde gekündigt. Du hast bis zum Ende des Abrechnungszeitraums noch Pro-Zugang.',
	'billing.managePlan': 'Plan verwalten',
	'billing.earlyAccess.title': 'Noch ein kleines bisschen Geduld',
	'billing.earlyAccess.description':
		'Wir arbeiten gerade an der Zahlung und Planverwaltung. Du kannst deinen Plan hier in Kürze upgraden.',
	'billing.invoices.title': 'Rechnungen',
	'billing.invoices.loading': 'Rechnungen werden geladen…',
	'billing.invoices.empty': 'Noch keine Rechnungen.',
	'billing.invoices.download': 'Herunterladen',
	'billing.invoices.col.date': 'Datum',
	'billing.invoices.col.number': 'Rechnungsnummer',
	'billing.invoices.col.total': 'Summe',
	'billing.invoices.col.status': 'Status',
	'billing.invoices.col.download': 'Download',
	'billing.invoices.status.draft': 'Entwurf',
	'billing.invoices.status.open': 'Offen',
	'billing.invoices.status.paid': 'Bezahlt',
	'billing.invoices.status.uncollectible': 'Uneinbringlich',
	'billing.invoices.status.void': 'Storniert',
	'billing.cancel.title': 'Abo kündigen',
	'billing.cancel.description':
		'Dein Plan bleibt bis zum Ende des aktuellen Abrechnungszeitraums aktiv. Danach wirst du auf den Free-Plan heruntergestuft.',
	'billing.cancel.confirm': 'Kündigung Bestätigen',
	'billing.cancel.keep': 'Abo behalten',
	'billing.cancel.success': 'Dein Abo wurde gekündigt und verlängert sich nicht mehr.',
	'billing.cancel.error': 'Abo konnte nicht gekündigt werden. Bitte versuche es erneut.',
	'billing.cancel.feedback': 'Bevor du gehst — sag uns, was wir verbessern können:',
	'billing.cancel.feedbackLink': 'Feedback senden',
	'billing.reactivate': 'Reaktivieren',
	'billing.reactivate.error': 'Abo konnte nicht reaktiviert werden. Bitte versuche es erneut.',
	'billing.cancellation.title': 'Kündigung',
	'billing.cancellation.cancelPlan': 'Plan kündigen',
	'billing.cancellation.cancelButton': 'Kündigen',
	'billing.cancellation.endingOn': 'Dein Abo endet am {{date}}. Du kannst jederzeit reaktivieren.',
	'billing.cancellation.ending': 'Dein Abo endet demnächst. Du kannst jederzeit reaktivieren.',
	'billing.credits.buyMore': 'Credits kaufen',
	'billing.credits.intro':
		'Credits erhöhen dein Chat-Kontingent. Jede Chat-Nachricht zieht Credits von deinem Guthaben ab. Der Kauf ist einmalig und ohne wiederkehrende Kosten. Credit-Pakete haben eine Laufzeit von einem Jahr oder bis sie aufgebraucht sind.',
	'billing.credits.packageCredits': '{{credits}} Credits',
	'billing.credits.savings': '+{{percent}}% mehr Credits',
	'billing.credits.confirmationTitle': 'Credits hinzugefügt',
	'billing.credits.confirmationBody': '{{credits}} Credits wurden deinem Konto gutgeschrieben.',
	'billing.credits.buyNow': 'Jetzt kaufen',
	'billing.credits.acceptTermsBefore':
		'Mit Klick auf „Jetzt kaufen" bestätigst du, dass du unserer ',
	'billing.credits.estimatedMessages': 'ca. {{min}}–{{max}} Anfragen',
	'billing.credits.estimatedMessagesDisclaimer': 'Anfragen-Richtwerte je nach Anfragekomplexität',
	'billing.credits.usageTitle': 'Wie weit reichen Credits?',
	'billing.credits.usageParagraph':
		'Credits werden pro Antwort verbraucht. Wie viele es sind, hängt davon ab, wie komplex deine Frage ist und wie viel die KI recherchieren muss. Kurze, direkte Fragen verbrauchen sehr wenige Credits. Lange Gespräche und Anfragen, bei denen viele Dokumente durchsucht werden, verbrauchen mehr.',
	'billing.credits.exampleShortLabel': 'Direkte Frage',
	'billing.credits.exampleShortText': 'z.B. „In welcher Partei ist Lars Klingbeil?"',
	'billing.credits.exampleShortCredits': '5–20 Credits',
	'billing.credits.exampleStandardLabel': 'Recherche mit Quellen',
	'billing.credits.exampleStandardText':
		'z.B. „Was hat der Bundestag zum Klimaschutz beschlossen?"',
	'billing.credits.exampleStandardCredits': '20–50 Credits',
	'billing.credits.exampleDeepLabel': 'Umfangreiche Analyse',
	'billing.credits.exampleDeepText':
		'z.B. „Vergleiche detailliert, wie die Parteien im Bundestag über die Wohnungspolitik debattiert haben."',
	'billing.credits.exampleDeepCredits': '100–300 Credits',
	'billing.credits.planUpsellTitle': 'Monatliches Kontingent, personalisierte Briefings und mehr',
	'billing.credits.planUpsellBody':
		'Unsere monatlichen Abos geben dir mehr als nur Chat-Zugang: ein höheres Nutzungskontingent und tolle Funktionen wie personalisierte Briefings. Wenn du ParlamentAI regelmäßig nutzt, ist ein Abo wahrscheinlich die bessere Wahl.',
	'billing.credits.viewPlans': 'Abos ansehen',
	'plan.upgrade.earlyAdopterNotice':
		'Du bist im Essential-Plan als Dankeschön für deine frühe Anmeldung!',
	'plan.limitReached.title': 'Chat-Limit erreicht',
	'plan.limitReached.description':
		'Du hast alle {{count}} Chats in deinem {{plan}}-Plan verwendet. Upgrade um weiterzuchatten.',
	'plan.limitReached.cta': 'Plan upgraden',
	'briefing.personalized.planGate.title': 'Nur im Pro-Plan verfügbar',
	'briefing.personalized.planGate.description':
		'Personalisierte Briefings sind für Pro-Plan-Nutzer verfügbar. Upgrade um täglich Briefings zu deinen Themen zu erhalten.',
	'briefing.personalized.planGate.cta': 'Plan upgraden',
	'briefing.personalized.chatGate.title': 'Pro-Plan erforderlich',
	'briefing.personalized.chatGate.description':
		'Rückfragen in personalisierten Briefings sind nur im Pro-Plan verfügbar.',
	'briefing.personalized.chatGate.cta': 'Auf Pro upgraden',

	// Landing Page
	'landing.hero.brandTag': 'Ein Angebot von der',
	'landing.hero.headline': 'Die Chatbot-Plattform, der du vertrauen kannst',
	'landing.hero.subheadline':
		'Botbakery Platform integriert deine Wissensquellen mit dem LLM deiner Wahl. Mit verifizierbaren Quellenangaben, DSGVO-konform und in der EU gehostet.',
	'landing.hero.cta': 'Demo vereinbaren',

	// Value Propositions
	'landing.benefits.heading': 'Warum Botbakery Platform?',
	'landing.benefits.citations.title': 'Verifizierbare Antworten durch präzise Zitate',
	'landing.benefits.customKnowledge.title': 'Individuelles Wissen für dich integriert',
	'landing.benefits.verifiable.title': 'Verifizierbare Antworten',
	'landing.benefits.verifiable.text':
		'Jede Antwort enthält vollständige Quellenangaben, damit du Informationen verifizieren und Halluzinationen verhindern kannst.',
	'landing.benefits.private.title': 'Deine privaten Wissensinhalte',
	'landing.benefits.private.text':
		'Integriere interne Dokumente, Wikis und Datenbanken. Dein Wissen bleibt sicher und privat.',
	'landing.benefits.gdpr.title': 'DSGVO-konform',
	'landing.benefits.gdpr.text':
		'In der EU gehostet mit vollständiger DSGVO-Konformität. Deine Daten verlassen niemals Europa.',
	'landing.benefits.custom.title': 'Individuelle Integrationen',
	'landing.benefits.custom.text':
		'Bereitstellung über API, Web-Widget oder individuelle Integration. Entwickelt für deinen Workflow.',

	// How It Works
	'landing.howItWorks.heading': 'So funktioniert es',
	'landing.howItWorks.step1.title': 'Verbinde dein Wissen',
	'landing.howItWorks.step1.description':
		'Importiere Dokumente, Wikis, Datenbanken und alle Wissensquellen, die deine Organisation nutzt.',
	'landing.howItWorks.step2.title': 'Passe deinen Assistenten an',
	'landing.howItWorks.step2.description':
		'Konfiguriere RAG-Parameter, wähle KI-Modelle aus und passe alles für deine Domäne an.',
	'landing.howItWorks.step3.title': 'Überall bereitstellen',
	'landing.howItWorks.step3.description':
		'Nutze es über API, binde es als Widget ein oder integriere es in deine vorhandenen Tools.',

	// RAG Pipeline (detailed)
	'landing.ragPipeline.heading': 'Wie funktioniert die Botbakery Platform?',
	'landing.ragPipeline.intro':
		'Retrieval-Augmented Generation (RAG) kombiniert gezieltes Durchsuchen eurer Dokumente mit der Sprachfähigkeit moderner KI. Anders als generische Chatbots, die "aus dem Bauch heraus" antworten, holt Botbakery Platform sich erst die relevanten Fakten aus euren Datenbanken – und generiert dann eine präzise Antwort auf Basis dieser Quellen. Das Resultat: verlässliche, belegbare Antworten statt halluzinierter "Fakten".',
	'landing.ragPipeline.step1.title': 'Dokument-Vorverarbeitung',
	'landing.ragPipeline.step1.description':
		'Wir verarbeiten eure Dokumente mit intelligentem Chunking, erstellen Zusammenfassungen und extrahieren Metadaten für optimale Durchsuchbarkeit',
	'landing.ragPipeline.step2.title': 'Intent Detection',
	'landing.ragPipeline.step2.description':
		'Wir analysieren die Nutzeranfrage, um ihre Intention zu verstehen – das leitet die Pipeline zu relevanteren Ergebnissen und bestimmt, ob Retrieval notwendig ist oder das Modell direkt antworten kann',
	'landing.ragPipeline.step3.title': 'Multi-Stage Retrieval',
	'landing.ragPipeline.step3.description':
		'Wir führen Retrieval mehrfach in aufeinanderfolgenden Stufen durch und kommen dabei dem benötigten Wissen immer näher – beginnend mit Dokumentzusammenfassungen, dann eingrenzend auf spezifische Passagen',
	'landing.ragPipeline.step4.title': 'Reranking',
	'landing.ragPipeline.step4.description':
		'Wir sortieren alle gefundenen Ergebnisse nach tatsächlicher Relevanz für die konkrete Frage und wählen die optimalen Informationen für den KI-Kontext aus',
	'landing.ragPipeline.step5.title': 'Antwortgenerierung & Zitation',
	'landing.ragPipeline.step5.description':
		'Wir generieren eine präzise Antwort basierend auf den gefundenen Quellen und fügen automatisch Quellenangaben ein, die jede Aussage zurück zu den Originaldokumenten verlinken – für volle Transparenz',

	// Use Cases
	'landing.useCases.heading': 'Für deinen Workflow entwickelt',
	'landing.useCases.internal.title': 'Internes Wissensmanagement',
	'landing.useCases.internal.description':
		'Gib deinem Team sofortigen Zugriff auf Unternehmenswissen, Richtlinien und Dokumentation.',
	'landing.useCases.customer.title': 'Customer Success',
	'landing.useCases.customer.description':
		'Automatisiere Support mit präzisen, zitierten Antworten auf Kundenfragen.',
	'landing.useCases.technical.title': 'Technische Dokumentation',
	'landing.useCases.technical.description':
		'Hilf Entwicklern, API-Details, Code-Beispiele und Integrationsanleitungen zu finden.',
	'landing.useCases.research.title': 'Forschung & Analyse',
	'landing.useCases.research.description':
		'Durchsuche Berichte, Studien und Daten mit KI-gestützten Insights.',

	// Comparison
	'landing.comparison.heading': 'Warum nicht einfach ChatGPT verwenden?',
	'landing.comparison.sources': 'Quellenangaben',
	'landing.comparison.astlai.sources': 'Vollständige Quellenangaben für jede Antwort',
	'landing.comparison.chatgpt.sources': 'Keine Quellenangaben',
	'landing.comparison.knowledge': 'Privates Wissen',
	'landing.comparison.astlai.knowledge': 'Vollständiger Zugriff auf deine Dokumente',
	'landing.comparison.chatgpt.knowledge': 'Nur öffentliche Trainingsdaten',
	'landing.comparison.compliance': 'DSGVO-Konformität',
	'landing.comparison.astlai.compliance': 'In der EU gehostet, DSGVO-konform',
	'landing.comparison.chatgpt.compliance': 'In den USA gehostet',
	'landing.comparison.customization': 'Anpassung',
	'landing.comparison.astlai.customization': 'Domänenspezifisches Tuning',
	'landing.comparison.chatgpt.customization': 'Generische Antworten',

	// FAQ
	'landing.faq.heading': 'Häufig gestellte Fragen',
	'landing.faq.whatIsRag.question': 'Wofür steht RAG?',
	'landing.faq.whatIsRag.answer':
		'RAG steht für Retrieval-Augmented Generation (Abruf-erweiterte Generierung). Es ist eine KI-Technik, die die Leistung großer Sprachmodelle mit deiner eigenen Wissensbasis kombiniert. Anstatt sich ausschließlich auf die Trainingsdaten der KI zu verlassen, rufen RAG-Systeme relevante Informationen aus deinen Dokumenten ab und verwenden sie, um präzise Antworten mit Quellenangaben zu generieren.',
	'landing.faq.gdprCompliant.question': 'Ist Botbakery Platform DSGVO-konform?',
	'landing.faq.gdprCompliant.answer':
		'Ja, absolut. Unsere Plattform ist vollständig DSGVO-konform und in der EU gehostet. Die gesamte Datenverarbeitung erfolgt in europäischen Rechenzentren, deine Daten verlassen niemals die EU, und wir befolgen strenge Datenschutzprotokolle. Wir stellen Auftragsverarbeitungsverträge (AVV) und umfassende Dokumentation für Datenschutzbeauftragte bereit.',
	'landing.faq.privateKnowledge.question': 'Kann ich mein eigenes privates Wissen integrieren?',
	'landing.faq.privateKnowledge.answer':
		'Ja! Genau dafür ist Botbakery Platform entwickelt. Du kannst interne Dokumente, Wikis, Datenbanken, technische Dokumentation und alle anderen Wissensquellen deiner Organisation integrieren. Wir kümmern uns um die gesamte ETL-Pipeline, Chunking, Embedding-Generierung und Bereitstellung. Dein Wissen bleibt privat und sicher.',
	'landing.faq.whyNotChatGPT.question': 'Warum nicht einfach ChatGPT verwenden?',
	'landing.faq.whyNotChatGPT.answer':
		'ChatGPT ist zwar leistungsstark, hat aber Einschränkungen für den Unternehmenseinsatz: Keine Quellenangaben—du kannst nicht nachvollziehen, woher Informationen stammen. Kein privates Wissen—kein Zugriff auf deine internen Dokumente. Halluzinationen—kann plausible, aber falsche Informationen generieren. Generische Antworten—nicht auf deine Domäne zugeschnitten. Botbakery Platform löst diese Probleme mit vollständigen Quellenangaben, Integration privater Wissensinhalte und domänenspezifischer Anpassung—alles DSGVO-konform und in der EU gehostet.',
	'landing.faq.useCases.question': 'Wofür kann ich einen Botbakery Platform Bot verwenden?',
	'landing.faq.useCases.answer':
		'Häufige Anwendungsfälle sind: Internes Wissensmanagement—gib Mitarbeitern sofortigen Zugriff auf Unternehmenswissen. Customer Success—automatisiere Support mit präzisen, zitierten Antworten. Technische Dokumentation—hilf Entwicklern, API-Details und Code-Beispiele zu finden. Forschung & Analyse—durchsuche Berichte, Studien und Daten. Compliance & Recht—frage Richtlinien, Vorschriften und Rechtsdokumente ab. Schulung & Onboarding—biete neuen Mitarbeitern interaktiven Wissenszugang.',
	'landing.faq.trustAnswers.question': 'Kann ich den Antworten vertrauen?',
	'landing.faq.trustAnswers.answer':
		'Obwohl kein KI-System 100%ige Genauigkeit garantieren kann, bietet Botbakery Platform beispiellose Transparenz durch vollständige Quellenangaben. Jede Antwort enthält Verweise auf die exakten Dokumente und Passagen, die verwendet wurden, sodass du Informationen selbst überprüfen kannst. Dies reduziert Halluzinationen drastisch und schafft Vertrauen. Überprüfe immer die Quellen für kritische Entscheidungen.',
	'landing.faq.cost.question': 'Was kostet es?',
	'landing.faq.cost.answer':
		'Die Botbakery Plattform ist ein individueller Integrationsdienst, kein fertiges Produkt. Die Preise hängen von deinen spezifischen Anforderungen ab: Datenvolumen, Aktualisierungshäufigkeit, Anpassungswünsche und Bereitstellungsmethode. Kontaktiere uns für ein personalisiertes Angebot. Wir konzentrieren uns auf die Bereitstellung qualitativ hochwertiger, domänenspezifischer Lösungen statt Einheitslösungen.',
	'landing.faq.integrationTime.question': 'Wie lange dauert die Integration?',
	'landing.faq.integrationTime.answer':
		'Die Integration dauert in der Regel 2-6 Wochen, abhängig von der Komplexität. Einfache Dokumentenimporte können in wenigen Tagen einsatzbereit sein, während komplexe Multi-Quellen-Integrationen mit benutzerdefinierten Workflows länger dauern können. Wir geben dir während der Erstberatung eine detaillierte Zeitplanung.',
	'landing.faq.aiModels.question': 'Welche KI-Modelle unterstützt ihr?',
	'landing.faq.aiModels.answer':
		'Wir unterstützen alle großen KI-Anbieter, darunter OpenAI (GPT-Modelle), Anthropic (Claude) und Scaleway/Mistral. Wir helfen dir, das beste Modell für deinen Anwendungsfall basierend auf Sprachunterstützung, Kosten und Leistungsanforderungen auszuwählen.',

	// CTA
	'landing.cta.heading': 'Bereit, deinen Wissensassistenten zu erstellen?',
	'landing.cta.description': 'Starte noch heute mit einer individuellen RAG-Integration',
	'landing.cta.button': 'Demo buchen'
};

export const translations = { en, de };
export type Locale = keyof typeof translations;
export type I18nKey = keyof typeof en;

export const locales = Object.keys(translations) as Locale[];
